import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip as Tool,
  Divider,
  IconButton,
  Popover,
  ListItemButton,
  DialogTitle,
  Alert,
  List,
  ListItem,
  ListItemText,
  MenuList,
  Checkbox,
} from "@mui/material";
// import Menu from "@mui/material/Menu";
import * as React from "react";
import Title from "../../Components/Title";
import { useContext, useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { PreferencesContext } from "../../PreferencesContext";
import "../../Theme/main.scss";
import { useNavigate } from "react-router-dom";
import { PdfViewer } from "../../Components/PdfViewer";
import TransportInvoicePreview from "../../Components/TransportInvoicePreview";
import TransportInvoiceBodyOnlyPreview from "../../Components/TransportInvoiceBodyOnlyPreview";
import TransportationDetailsReportPreview from "../../Components/TransportationDetailsReportPreview";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import { format, isWithinInterval, startOfDay } from "date-fns";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import { PAGE_SIZES } from "../../Services/common/const";
import {
  GetSaleList,
  DeleteSale,
  GetPrintInvoice,
  GetTransportInvoiceReport,
} from "../../Services/SaleService";
import DownloadIcon from "@mui/icons-material/Download";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import { AlertType } from "../../shared/Modal/AlertType";
import { DateRange } from "react-date-range";
import {
  Chart as ChartJS,
  ArcElement,
  Legend,
  Tooltip,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import { GetDashboard } from "../../Services/DashboardService";
import DateRangeIcon from "@mui/icons-material/DateRange";
import {
  numDifferentiation,
  numberFormat,
  getCurrentFinancialYear,
  ExportFilesFunction,
  NumberFormatWithSymbol,
} from "../../shared/CommonFuctions";
import { useTheme } from "@mui/material/styles";
import {
  GeneratePrintInvoiceEWayBill,
  GetEWayBillDriverCopy,
  GetEWayBillOriginalCopy,
  GetLWHPrintInvoiceReport,
  GetLandScapePrintInvoiceReport,
   GetPrintInvoiceHtml,                 // <-- ADD
  GetTaxInvoiceHtmlWithRightSideLogo, 
} from "../../Services/ReportService";
import { EncryptDecryptService } from "../../Services/common/EncryptionService";
import {
  SummaryCardValueSkeleton,
  GstCardValueSkeleton,
  AgingStripSkeleton,
  BarChartSkeleton,
  DonutChartSkeleton,
  BankCashSkeleton,
  TableRowsSkeleton,
} from "../../Components/DashboardSkeleton/DashboardSkeleton";
import ReactECharts from "echarts-for-react";
import MenuItem from "@mui/material/MenuItem";
import {
  usePopupState,
  bindTrigger,
  bindMenu,
} from "material-ui-popup-state/hooks";
import { styled, alpha } from "@mui/material/styles";
import Menu, { MenuProps } from "@mui/material/Menu";
import { EmailDialog } from "../../Components/EmailSendDailog";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { GetUserDetail } from "../../Services/UserService";
import InvoiceTemplateSelection from "../../Components/InvoiceTemplateSelection";
import { BootstrapTooltip } from "../../Components/BootStrapToolTip";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { EWAY_BILL_ACCESS_CONSUMERS } from "../../StaticData/DataHelper";
import { CheckUserNameAndPasswordIsExist } from "../../Services/MasterService";
import { Reject as RejectEWayBill } from "../../Services/EWayBillService";
import MissingConsumer from "../../Components/MissingConsumer";
import { GetDocumentList } from "../../Services/DocumentService";
import ShortcutButton from "../../Components/ShortcutButton";
import CustomColumn from "../../Assets/custom-column.svg";
import LockIcon from "@mui/icons-material/Lock";
import {
  CreateConfiguration,
  GetSystemConfigurationById,
  UpdateConfiguration,
} from "../../Services/SystemConfigurationService";
ChartJS.register(
  ArcElement,
  Legend,
  Tooltip,
  CategoryScale,
  LinearScale,
  BarElement,
);
interface Data {
  saleId: number;
  saleType: string;
  saleDate: string;
  none: string;
}
interface EnhancedTableProps {
  numSelected: number;
  //onRequestSort: (event: React.MouseEvent<unknown>, property: keyof Data) => void;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  order: Order;
  orderBy: String;
  rowCount: number;
  visibleColumns?: {
    showVoucherNumber: boolean;
    showVoucherDate: boolean;
    showDueDate: boolean;
    showQuantity: boolean;
    showTotalAmount: boolean;
    showStatus: boolean;
    showProfitAmount: boolean;
    showProfitPercent: boolean;
  };
}
function EnhancedTableHead(props: EnhancedTableProps) {
  const {
    showVoucherNumber,
    showVoucherDate,
    showDueDate,
    showQuantity,
    showTotalAmount,
    showStatus,
    showProfitAmount,
    showProfitPercent,
  } = props.visibleColumns || {
    showVoucherNumber: true,
    showVoucherDate: true,
    showDueDate: true,
    showQuantity: true,
    showTotalAmount: true,
    showStatus: true,
    showProfitAmount: true,
    showProfitPercent: true,
  };

  return (
    // checkBox for Header
    <TableHead className="table-header-color">
      <TableRow>
        <TableCell align="left" width={"20px"}></TableCell>
        {showVoucherNumber && (
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              minWidth: "110px",
              fontWeight: "bold",
            }}
            align="left"
          >
            {"Voucher #"}
          </TableCell>
        )}
        {showVoucherDate && (
          <TableCell
            sx={{
              display: {
                xs: "none",
                sm: "none",
                md: "table-cell",
                lg: "table-cell",
              },
              minWidth: "110px",
              fontWeight: "bold",
            }}
            align="center"
          >
            {"Voucher Date"}
          </TableCell>
        )}
        {showDueDate && (
          <TableCell
            sx={{
              display: {
                xs: "none",
                sm: "none",
                md: "table-cell",
                lg: "table-cell",
              },
              minWidth: "110px",
              fontWeight: "bold",
            }}
            align="center"
          >
            {"Due Date"}
          </TableCell>
        )}
        {showQuantity && (
          <TableCell
            sx={{
              display: {
                xs: "none",
                sm: "none",
                md: "none",
                lg: "table-cell",
              },
              minWidth: "110px",
              fontWeight: "bold",
            }}
            align="right"
          >
            {"Quantity"}
          </TableCell>
        )}
        {showTotalAmount && (
          <TableCell
            sx={{
              display: {
                xs: "none",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              minWidth: "110px",
              fontWeight: "bold",
            }}
            align="right"
          >
            {"Amount ₹"}
          </TableCell>
        )}
        {showStatus && (
          <TableCell
            sx={{
              display: {
                xs: "none",
                sm: "none",
                md: "table-cell",
                lg: "table-cell",
              },
              minWidth: "110px",
              fontWeight: "bold",
            }}
            align="left"
          >
            {"Status"}
          </TableCell>
        )}
        {showProfitAmount && (
          <TableCell
            sx={{
              display: {
                xs: "none",
                sm: "none",
                md: "table-cell",
                lg: "table-cell",
              },
              minWidth: "120px",
              fontWeight: "bold",
            }}
            align="right"
          >
            {"Profit Amount (₹)"}
          </TableCell>
        )}

        {showProfitPercent && (
          <TableCell
            sx={{
              display: {
                xs: "none",
                sm: "none",
                md: "table-cell",
                lg: "table-cell",
              },
              minWidth: "120px",
              fontWeight: "bold",
            }}
            align="right"
          >
            {"Profit (%)"}
          </TableCell>
        )}
        <TableCell></TableCell>
      </TableRow>
    </TableHead>
  );
}

function EnhancedTableAllHead(props: EnhancedTableProps) {
  return (
    <TableHead className="table-header-color">
      <TableRow>
        <TableCell
          sx={{
            display: {
              xs: "table-cell",
              sm: "table-cell",
              md: "table-cell",
              lg: "table-cell",
            },
            fontWeight: "bold",
          }}
          align="left"
        >
          {"Type"}
        </TableCell>
        <TableCell
          sx={{
            display: {
              xs: "table-cell",
              sm: "table-cell",
              md: "table-cell",
              lg: "table-cell",
            },
            fontWeight: "bold",
          }}
          align="left"
        >
          {"Document Name"}
        </TableCell>
        <TableCell
          sx={{
            display: {
              xs: "table-cell",
              sm: "table-cell",
              md: "table-cell",
              lg: "table-cell",
            },
            fontWeight: "bold",
          }}
          align="left"
        >
          {"Registration No"}
        </TableCell>
        <TableCell
          sx={{
            display: {
              xs: "table-cell",
              sm: "table-cell",
              md: "table-cell",
              lg: "table-cell",
            },
            fontWeight: "bold",
          }}
          align="left"
        >
          {"Expiration Date"}
        </TableCell>
        {/* <TableCell sx={{ width: "5%" }}></TableCell> */}
      </TableRow>
    </TableHead>
  );
}

const sale: any = {
  saleCollection: [],
};

const document: any = {
  documentCollection: [],
};

const parameters: any = {
  consumerId: 1,
  startDate: "",
  endDate: "",
  pageIndex: 1,
  pageSize: PAGE_SIZES,
  sortColumn: "",
  sortDirection: "",
  searchValue: "",
};
const edService = new EncryptDecryptService();
function stableSort<T>(
  array: readonly T[],
  comparator: (a: T, b: T) => number,
) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
type Order = "asc" | "desc" | "";
function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key,
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string },
) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
export default function Dashboard() {
  const popupState = usePopupState({ variant: "popover", popupId: "demoMenu" });
  const [eWayBillUpdate, setEWayBillUpdate] = React.useState({
    open: false,
    type: "",
    eWayBillId: 0,
  });
  let navigate = useNavigate();
  const matches = useMediaQuery("(max-width:400px)");
  const Purchasedata = {
    title: "Add Purchase",
    button: "Save",
  };
  const Saledata = {
    title: "Add Invoice",
    button: "Save",
    saleId: 0,
  };
  const handleCloseInvoiceDownload = () => {
    setopenInvoiceDownload(false);
  };
  const handleClose = () => {
    setopenDilog(false);
    setAnchorEl3(null);
  };
  const handleClickOpenMore = (
    event: React.MouseEvent<HTMLButtonElement>,
    id: any,
    item: any,
  ) => {
    setAnchorEl3(event.currentTarget);
    setSaleId(id);
    setDialogSaleData(item);
    setItemData(item);
  };
  const handleCloseInvoice = () => {
    setOpeninvoice(false);
    setReportName("");
    setTransportInvoiceData(null);
  };
  const containerRef = React.useRef(null);
  const [anchorEl2, setAnchorEl2] = React.useState<null | HTMLElement>(null);
  const [state, setState] = useState(Purchasedata);
  const [invoiceTitle, setInvoiceTitle] = React.useState("");
  const [fileToken, setFileToken] = React.useState("");
  const [stateInvoice, setstateInvoice] = useState(Saledata);
  const [dense, setDense] = React.useState(false);
  const [selected, setSelected] = React.useState<readonly number[]>(
    sale.saleCollection,
  );
  const [anchorEl, setAnchorEl3] = React.useState<HTMLButtonElement | null>(
    null,
  );
  const [anchorE4, setAnchorEl4] = React.useState<HTMLButtonElement | null>(
    null,
  );
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const open2 = Boolean(anchorEl2);
  const [order, setOrder] = React.useState<Order>("");
  const [orderBy, setOrderBy] = React.useState<keyof Data>("none");
  const [resultData, setResultData] = useState(sale);
  const [documentData, setDocumentData] = useState(document);
  const [isLoading, setLoading] = React.useState(false);
  const [isDashboardLoading, setIsDashboardLoading] = React.useState(true);
  const [isInvoiceListLoading, setIsInvoiceListLoading] = React.useState(true);
  const [isDocumentLoading, setIsDocumentLoading] = React.useState(true);
  const open = Boolean(anchorEl);
  const [saleId, setSaleId] = React.useState<any>(0);
  const [dialogSaleData, setDialogSaleData] = React.useState<any>({});
  const [InvoiceName, setInvoiceName] = React.useState<string>("");
  const [page_Index, setPage_Index] = useState(1);
  const [openDilog, setopenDilog] = React.useState(false);
  const [invoiceHtml, setInvoiceHtml] = React.useState("");
  const [param, setParam] = useState(parameters);
  const [scroll, setScroll] = React.useState<DialogProps["scroll"]>("paper");
  const [openInvoice, setOpeninvoice] = React.useState(false);
  const [value, setValue] = useState("");
  const [isAllowAdd, setAllowAdd] = React.useState(true);
  const [counter, setCounter] = React.useState(0);
  const [dashboardData, setDashboardData] = useState<any>(null);
  const [openInvoiceDownload, setopenInvoiceDownload] = React.useState(false);
  const [invoiceHtmlDownload, setInvoiceHtmlDownload] = React.useState("");
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  const [invoiceHtmlTitle, setInvoiceHtmlTitle] = React.useState("");
  const matchesForInvoice = useMediaQuery("(max-width:899px)");
  const matchesForCharts = useMediaQuery("(max-width:470px)");
  const [settingsAnchorEl, setSettingsAnchorEl] =
    React.useState<HTMLElement | null>(null);
  const [invoiceReportSelectionDialog, setInvoiceReportSelectionDialog] =
    React.useState(false);

  const configurationSetting = React.useMemo(() => {
    return userContext?.systemConfigurationColl?.find(
      (item: any) =>
        item?.configModule === "SALE_LIST" && item?.configKey === "SHOW_FIELDS",
    );
  }, [userContext?.systemConfigurationColl]);

  const reportConfigList = React.useMemo(() => {
    return (
      userContext?.systemConfigurationDetailColl?.filter(
        (item: any) =>
          item?.parentConfigurationModule === "SALE_LIST" &&
          item?.configModule === "SHOW_FIELDS",
      ) || []
    );
  }, [userContext?.systemConfigurationDetailColl, configurationSetting]);

  const [reportConfigDetail, setReportConfigDetail] = React.useState<any[]>([]);

  useEffect(() => {
    setReportConfigDetail(
      reportConfigList.map((item: any) => ({
        ...item,
        isChecked: item?.configValue === "1",
      })),
    );
  }, [reportConfigList]);

  const reportConfig = React.useMemo(() => {
    return (reportConfigDetail || []).reduce(
      (acc: Record<string, boolean>, item: any) => {
        acc[String(item.configKey || "")] = Boolean(item.isChecked);
        return acc;
      },
      {},
    );
  }, [reportConfigDetail]);

  const normalizeConfigToken = React.useCallback((value: any) => {
    return String(value ?? "")
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
  }, []);

  const isSaleFieldVisible = React.useCallback(
    (aliases: string[]) => {
      if (!reportConfigDetail?.length) {
        return true;
      }

      const normalizedAliases = aliases
        .map((alias) => normalizeConfigToken(alias))
        .filter(Boolean);

      const hasDirectConfigMatch = normalizedAliases.some(
        (alias) => reportConfig[alias] !== undefined,
      );

      if (hasDirectConfigMatch) {
        return normalizedAliases.some((alias) => reportConfig[alias] === true);
      }

      const matchingConfigRows = reportConfigDetail.filter(
        (configItem: any) => {
          const configKey = normalizeConfigToken(configItem?.configKey);
          const configLabel = normalizeConfigToken(configItem?.configKeyLabel);
          return (
            normalizedAliases.includes(configKey) ||
            normalizedAliases.includes(configLabel)
          );
        },
      );

      if (!matchingConfigRows.length) {
        return true;
      }

      return matchingConfigRows.some(
        (configItem: any) =>
          Boolean(configItem?.isChecked) || configItem?.configValue === "1",
      );
    },
    [normalizeConfigToken, reportConfig, reportConfigDetail],
  );

  const latestInvoiceVisibleColumns = React.useMemo(
    () => ({
      showVoucherNumber: isSaleFieldVisible([
        "VOUCHER",
        "VOUCHER_NO",
        "VOUCHER_NUMBER",
        "SALE_NUMBER",
      ]),
      showVoucherDate: isSaleFieldVisible([
        "VOUCHER_DATE",
        "SALE_DATE",
        "DATE",
      ]),
      showDueDate: isSaleFieldVisible(["DUE_DATE"]),
      showQuantity: isSaleFieldVisible(["QTY", "QUANTITY"]),
      showTotalAmount: isSaleFieldVisible([
        "TOTAL_AMOUNT",
        "TOTAL_AMT",
        "TOTAL",
        "AMOUNT",
      ]),
      showStatus: isSaleFieldVisible(["STATUS", "SALE_STATUS"]),
      showProfitAmount: isSaleFieldVisible(["PROFIT_AMOUNT"]),
      showProfitPercent: isSaleFieldVisible(["PROFIT_PERCENT"]),
    }),
    [isSaleFieldVisible],
  );

  const handleSettingsOpen = (event: React.MouseEvent<HTMLElement>) => {
    setSettingsAnchorEl(event.currentTarget);
  };

  const handleSettingsClose = () => {
    setSettingsAnchorEl(null);
  };

  const getSystemConfigurationById = async (configurationId: string) => {
    let params = new URLSearchParams();
    let configurationDetail: any = null;
    params.append("systemConfigurationId", configurationId?.toString() ?? "0");
    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    try {
      const result: any = await GetSystemConfigurationById(params);
      if (result?.data?.data) {
        configurationDetail = result.data.data;
      }
      return configurationDetail;
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  };

  const handleSettingsSave = async (configData: any[]) => {
    try {
      if ((configurationSetting?.masterSystemConfigurationId ?? 0) > 0) {
        const reportConfigDetailColl = configData?.map((config) => {
          if (config?.systemConfigurationDetailId > 0) {
            config.mode = "U";
          } else {
            config.mode = "I";
          }
          config.configValue = config.isChecked ? "1" : "0";
          return config;
        });

        let result: any = "";
        let formData = {
          systemConfigurationId:
            configurationSetting?.systemConfigurationId || 0,
          masterSystemConfigurationId:
            configurationSetting?.masterSystemConfigurationId || 0,
          consumerId: userContext?.consumerId,
          firmId: userContext?.firmId || 0,
          branchId: 0,
          userId: 0,
          isDeleted: configurationSetting?.isDeleted || false,
          dataManagedBy: userContext?.userId || 0,
          configModule: configurationSetting?.configModule || "",
          configValue: configurationSetting?.configValue || "",
          configKeyLabel: configurationSetting?.configKeyLabel || "",
          configKey: configurationSetting?.configKey || "",
          configDataType: configurationSetting?.configDataType || "",
          systemConfigurationDetailJson: JSON.stringify(
            reportConfigDetailColl || [],
          ),
        };

        if ((configurationSetting?.systemConfigurationId ?? 0) > 0) {
          result = await UpdateConfiguration(formData);
        } else {
          result = await CreateConfiguration(formData);
        }

        if (result?.data) {
          const updatedConfig = await getSystemConfigurationById(
            result?.data?.systemConfigurationId || 0,
          );
          setReportConfigDetail(configData);

          const systemConfigurationColl =
            userContext?.systemConfigurationColl?.map((item: any) => {
              if (
                item?.configModule === updatedConfig?.configModule &&
                item.configKey === updatedConfig?.configKey
              ) {
                return {
                  ...item,
                  systemConfigurationId: updatedConfig.systemConfigurationId,
                  configValue: updatedConfig.configValue,
                };
              }
              return item;
            });

          const systemConfigurationDetailColl =
            userContext?.systemConfigurationDetailColl?.map(
              (detailItem: any) => {
                const match =
                  updatedConfig?.systemConfigurationDetailColl?.find(
                    (item: any) =>
                      item?.parentConfigurationModule ===
                        detailItem?.parentConfigurationModule &&
                      item?.configModule === detailItem?.configModule &&
                      item?.configKey === detailItem?.configKey,
                  );
                if (match) {
                  return {
                    ...detailItem,
                    systemConfigurationId: match.systemConfigurationId,
                    systemConfigurationDetailId:
                      match.systemConfigurationDetailId,
                    masterSystemConfigurationId:
                      match.masterSystemConfigurationId,
                    configValue: match.configValue,
                  };
                }
                return detailItem;
              },
            );

          updateUserContext({
            ...userContext,
            isAlert: true,
            alertMessage: result?.message,
            alertType: AlertType.Success,
            systemConfigurationColl,
            systemConfigurationDetailColl,
          });
        }
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  };

  const detailClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl2(event.currentTarget);
  };
  const startDate =
    userContext.financialYear !== getCurrentFinancialYear() &&
    userContext.financialYear !== undefined &&
    getCurrentFinancialYear() !== undefined
      ? new Date(userContext.financialYearStartDate)
      : new Date().getTime() - 30 * 24 * 60 * 60 * 1000;
  const endDate =
    userContext.financialYear !== getCurrentFinancialYear() &&
    userContext.financialYear !== undefined &&
    getCurrentFinancialYear() !== undefined
      ? new Date(userContext.financialYearEndDate)
      : new Date();
  const [selectedDateRange, setDateRange] = useState<any>([
    {
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    },
  ]);
  const [defaultinvoiceNameObj, setDefaultinvoiceNameObj] =
    React.useState<any>();
  const [selectedIndex, setSelectedIndex] = React.useState(3);
  const [isCustomDate, setIsCustomDate] = React.useState(false);
  const [dateHeading, setDateHeading] = React.useState<any>("Last 30 days");
  const [isOpen, setIsOpen] = React.useState(false);
  const [reportName, setReportName] = React.useState<any>("");
  const [transportInvoiceData, setTransportInvoiceData] = useState<any>(null);
  const [finalTotalAmount, setFinalTotalAmount] = useState(0);
  const [dataId, setDataId] = React.useState(0);
  const [pdfFileName, setPdfFileName] = React.useState("");
  const [userName, setUserName] = useState("");
  const [itemData, setItemData] = React.useState<any[]>([]);
  useEffect(() => {
    const CurrentFinancialYear = getCurrentFinancialYear();
    if (userContext.financialYear < CurrentFinancialYear) {
      setDateHeading("Current financial year");
      setSelectedIndex(7);
    } else {
      if (userContext.consumerId === 160) {
        setDateHeading("This Month");
        setDateRange([
          {
            startDate: getStartOfThisMonth(),
            endDate: getEndOfThisMonth(),
            key: "selection",
          },
        ]);
        setSelectedIndex(5);
      } else {
        setDateHeading("Last 30 days");
        setSelectedIndex(3);
      }
    }
  }, [userContext.financialYear]);

  const getStartOfThisMonth = () => {
    return userContext.financialYear !== getCurrentFinancialYear()
      ? new Date(
          new Date(userContext.financialYearEndDate).getFullYear(),
          new Date(userContext.financialYearEndDate).getMonth(),
          1,
        )
      : new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  };

  const getEndOfThisMonth = () => {
    return userContext.financialYear !== getCurrentFinancialYear()
      ? new Date(userContext.financialYearEndDate)
      : new Date();
  };

  const getStartOfPreviousMonth = () => {
    return userContext.financialYear !== getCurrentFinancialYear()
      ? new Date(
          new Date(userContext.financialYearEndDate).getFullYear(),
          new Date(userContext.financialYearEndDate).getMonth() - 1,
          1,
        )
      : new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
  };

  const getEndOfPreviousMonth = () => {
    return userContext.financialYear !== getCurrentFinancialYear()
      ? new Date(
          new Date(userContext.financialYearEndDate).getFullYear(),
          new Date(userContext.financialYearEndDate).getMonth(),
          0,
        )
      : new Date(new Date().getFullYear(), new Date().getMonth(), 0);
  };

  const handleListItemClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    index: number,
  ) => {
    setSelectedIndex(index);
    switch (index) {
      case 0:
        setDateRange([
          {
            startDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate)
                : new Date(),
            endDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate)
                : new Date(),
            key: "selection",
          },
        ]);
        setDateHeading("Today");
        break;
      case 1:
        setDateRange([
          {
            startDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate).getTime() -
                  1 * 24 * 60 * 60 * 1000
                : new Date().getTime() - 1 * 24 * 60 * 60 * 1000,
            endDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate).getTime() -
                  1 * 24 * 60 * 60 * 1000
                : new Date().getTime() - 1 * 24 * 60 * 60 * 1000,
            key: "selection",
          },
        ]);
        setDateHeading("Yestarday");
        break;
      case 2:
        setDateRange([
          {
            startDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate).getTime() -
                  14 * 24 * 60 * 60 * 1000
                : new Date().getTime() - 14 * 24 * 60 * 60 * 1000,
            endDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate)
                : new Date(),
            key: "selection",
          },
        ]);
        setDateHeading("Last 15 days");
        break;
      case 3:
        setDateRange([
          {
            startDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate).getTime() -
                  29 * 24 * 60 * 60 * 1000
                : new Date().getTime() - 29 * 24 * 60 * 60 * 1000,
            endDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate)
                : new Date(),
            key: "selection",
          },
        ]);
        setDateHeading("Last 30 days");
        break;
      case 4:
        setDateRange([
          {
            startDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate).getTime() -
                  89 * 24 * 60 * 60 * 1000
                : new Date().getTime() - 89 * 24 * 60 * 60 * 1000,
            endDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate)
                : new Date(),
            key: "selection",
          },
        ]);
        setDateHeading("Last 90 days");
        break;
      case 5:
        setDateRange([
          {
            startDate: getStartOfThisMonth(),
            endDate: getEndOfThisMonth(),
            key: "selection",
          },
        ]);
        setDateHeading("This Month");
        break;
      case 6:
        setDateRange([
          {
            startDate: getStartOfPreviousMonth(),
            endDate: getEndOfPreviousMonth(),
            key: "selection",
          },
        ]);
        setDateHeading("Previous Month");
        break;
      case 7:
        setDateRange([
          {
            startDate: new Date(userContext.financialYearStartDate),
            endDate: new Date(userContext.financialYearEndDate),
            key: "selection",
          },
        ]);
        setDateHeading("Current financial year");
        break;
      case 8:
        // setDateHeading(`${formatDate(new Date(selectedDateRange[0].startDate))} To ${formatDate(new Date(selectedDateRange[0].endDate))}`)
        setIsCustomDate(true);
        break;
      default:
        break;
    }
  };

  async function handleOutstandingReceivablesNavigate(range: string) {
    try {
      const today = new Date();
      let sd: Date = today;
      let ed: Date = today;

      // 🔹 Define date logic based on selected range
      switch (range) {
        case "current":
          sd = today;
          ed = today;
          break;

        case "1to15":
          // 1–15 days overdue
          sd = new Date();
          sd.setDate(sd.getDate() - 15);
          ed = new Date();
          ed.setDate(ed.getDate() - 1);
          break;

        case "16to30":
          // 16–30 days overdue
          sd = new Date();
          sd.setDate(sd.getDate() - 30);
          ed = new Date();
          ed.setDate(ed.getDate() - 16);
          break;

        case "31to45":
          // 31–45 days overdue
          sd = new Date();
          sd.setDate(sd.getDate() - 45);
          ed = new Date();
          ed.setDate(ed.getDate() - 31);
          break;

        case "above45":
          // Above 45 days overdue
          sd = new Date(userContext?.financialYearStartDate);
          ed = new Date();
          ed.setDate(ed.getDate() - 46);
          break;

        default:
          break;
      }

      // 🔹 Format dates as yyyy-MM-dd (same as your other pages)
      const formattedStartDate = format(sd, "yyyy-MM-dd");
      const formattedEndDate = format(ed, "yyyy-MM-dd");

      // 🔹 Navigate (same pattern as Ledgermonthlist)
      navigate(
        {
          pathname: "/outstanding-receivable-new",
          search: `?sd=${formattedStartDate}&ed=${formattedEndDate}`,
        },
        {
          state: {
            startDate: formattedStartDate,
            endDate: formattedEndDate,
          },
        },
      );
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }
  async function handleOutstandingPayablesNavigate(range: string) {
    try {
      const today = new Date();
      let sd: Date = today;
      let ed: Date = today;

      // 🔹 Define date logic based on selected range
      switch (range) {
        case "current":
          sd = today;
          ed = today;
          break;

        case "1to15":
          // 1–15 days overdue
          sd = new Date();
          sd.setDate(sd.getDate() - 15);
          ed = new Date();
          ed.setDate(ed.getDate() - 1);
          break;

        case "16to30":
          // 16–30 days overdue
          sd = new Date();
          sd.setDate(sd.getDate() - 30);
          ed = new Date();
          ed.setDate(ed.getDate() - 16);
          break;

        case "31to45":
          // 31–45 days overdue
          sd = new Date();
          sd.setDate(sd.getDate() - 45);
          ed = new Date();
          ed.setDate(ed.getDate() - 31);
          break;

        case "above45":
          // Above 45 days overdue
          sd = new Date(userContext?.financialYearStartDate);
          ed = new Date();
          ed.setDate(ed.getDate() - 46);
          break;

        default:
          break;
      }

      // 🔹 Format dates as yyyy-MM-dd (same as your other pages)
      const formattedStartDate = format(sd, "yyyy-MM-dd");
      const formattedEndDate = format(ed, "yyyy-MM-dd");

      // 🔹 Navigate (same pattern as Ledgermonthlist)
      navigate(
        {
          pathname: "/outstanding-payable-new",
          search: `?sd=${formattedStartDate}&ed=${formattedEndDate}`,
        },
        {
          state: {
            startDate: formattedStartDate,
            endDate: formattedEndDate,
          },
        },
      );
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }
  const DueDateColorInline = ({ item }: { item: any }) => {
    const diffDate =
      new Date(item?.dueOnDate).getTime() - new Date(item?.saleDate).getTime();
    const diffDays = Math.abs(Math.floor(diffDate / (24 * 60 * 60 * 1000)));
    if (
      diffDays <= 7 &&
      ["OVERDUE", "PENDING", "PARTIAL_PAID"].includes(item.saleStatus)
    ) {
      return (
        <span style={{ color: "#dd3431" }}>
          {item.dueOnDate
            ? format(new Date(item.dueOnDate), "dd-MM-yyyy")
            : "-"}
        </span>
      );
    } else if (
      diffDays <= 15 &&
      ["OVERDUE", "PENDING", "PARTIAL_PAID"].includes(item.saleStatus)
    ) {
      return (
        <span style={{ color: "#ffa500" }}>
          {item.dueOnDate
            ? format(new Date(item.dueOnDate), "dd-MM-yyyy")
            : "-"}
        </span>
      );
    } else {
      return (
        <span style={{ color: "" }}>
          {item.dueOnDate
            ? format(new Date(item.dueOnDate), "dd-MM-yyyy")
            : "-"}
        </span>
      );
    }
  };
  const optionsSaleBarChart = {
    responsive: true,
    // plugins: {
    //   legend: {
    //     position: 'top' as const,
    //   },
    //   title: {
    //     display: true,
    //     text: 'Chart.js Bar Chart',
    //   },
    // },
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
        title: {
          display: false,
          text: "Amount",
        },
        ticks: {
          // Include a dollar sign in the ticks
          callback: function (value, index, ticks) {
            return numDifferentiation(value, 0);
          },
        },
      },
    },
  };

  async function assetLedgerEdit(asset: any) {
    try {
      if (asset.accountCode === "NO_LINK" && asset.ledgerAccountId === 0) {
        return false;
      } else if (asset.accountCode === "P_L" && asset.ledgerAccountId === 0) {
        navigate({
          pathname: "/profit-and-loss",
        });
      } else if (
        asset.ledgerAccountId === 0 &&
        !["NO_LINK", "P_L"].includes(asset.accountCode)
      ) {
        let eledgerAccountGroup: any = edService.encrypt(asset.particulars);
        navigate(
          {
            pathname: "/ledger-group-summary",
            search: `?q=${encodeURIComponent(eledgerAccountGroup)}`,
          },
          {
            state: { ledgerAccountGroup: asset.particulars },
          },
        );
      } else if (asset.ledgerAccountId > 0) {
        let enledgerAccountId: any = edService.encrypt(asset.ledgerAccountId);
        navigate(
          {
            pathname: "/ledger-summary",
            search: `?q=${encodeURIComponent(enledgerAccountId)}`,
          },
          {
            state: { ledgerAccountId: asset.ledgerAccountId },
          },
        );
      } else {
        return false;
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }
  const labels = dashboardData?.saleChart?.chartLabels;
  const isDarkMode = theme.palette.mode === "dark";
  const chartTextColor = isDarkMode ? "#F1F5F9" : "#5d6f80";
  const chartSplitLine = isDarkMode ? "#293241" : "#e0e0e0";
  const chartAxisLine = isDarkMode ? "#293241" : "#cccccc";
  const chartTooltipBg = isDarkMode ? "#151C26" : "#ffffff";
  var axisAlignwithTick = {
    color: [isDarkMode ? "#6366F1" : "#25258f"],
    backgroundColor: "transparent",
    textStyle: {
      color: chartTextColor,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      backgroundColor: chartTooltipBg,
      borderColor: chartSplitLine,
      textStyle: {
        color: chartTextColor,
      },
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        data: dashboardData?.saleChart?.chartLabels,
        axisTick: {
          alignWithLabel: true,
          lineStyle: { color: chartAxisLine },
        },
        axisLabel: { color: chartTextColor },
        axisLine: { lineStyle: { color: chartAxisLine } },
        //axisLabel: { interval: 0, rotate: 30 }
      },
    ],
    yAxis: [
      {
        type: "value",
        axisLabel: {
          color: chartTextColor,
          formatter: function (value: number) {
            return "₹ " + numberFormat(value);
          },
        },
        splitLine: { lineStyle: { color: chartSplitLine } },
        axisLine: { lineStyle: { color: chartAxisLine } },
      },
    ],
    series: [
      {
        name: "Amount",
        type: "bar",
        barWidth: "60%",
        // barHeight: '50%',
        tooltip: {
          valueFormatter: function (value) {
            return "₹ " + numberFormat(value);
          },
        },
        data: dashboardData?.saleChart?.chartData,
      },
    ],
  };

  var doughnutChart = {
    // labels: dashboardData?.soldItemChart.chartLabels,
    color: isDarkMode
      ? ["#ff6b81", "#6bb6ff", "#ffb347", "#b794f6", "#4fd1c5"]
      : [
          "rgba(233, 69, 96, 1)",
          "rgba(15, 52, 96, 1)",
          "rgba(255, 149, 81, 1)",
          "rgba(83, 52, 131, 1)",
          "rgba(33, 152, 151,1)",
        ],
    tooltip: {
      trigger: "item",
      responsive: true,
      position: "top",
      formatter: function (params) {
        return `₹ ${numberFormat(
          params.value,
        )}<br /> <small>N</small> ${numberFormat(params.data.qty)}`;
      },
      borderWidth: "0.8",
      backgroundColor: chartTooltipBg,
      borderColor: chartSplitLine,
      textStyle: {
        color: chartTextColor,
        fontSize: 14,
        width: 100,
        overflow: "break",
        fontWeight: "bold",
      },
    },
    backgroundColor: "transparent",
    textStyle: {
      color: chartTextColor,
    },
    legend: matchesForCharts
      ? {
          orient: "horizontal",
          top: "2%",
          left: "center",
          textStyle: { color: chartTextColor },
        }
      : {
          orient: "vertical",
          right: "right",
          top: "center",
          textStyle: {
            color: chartTextColor,
            width: 150,
            overflow: "truncate",
            ellipsis: "...",
          },
        },
    series: [
      {
        //name: 'Access From',
        type: "pie",
        radius: ["30%", "60%"],
        emptyCircleStyle: {
          color: isDarkMode ? "#1B2430" : "#e0e0e0",
        },
        itemStyle: {
          borderColor: isDarkMode ? "#151C26" : "#ffffff",
          borderWidth: 2,
        },
        avoidLabelOverlap: true,
        right: matchesForCharts ? "0%" : "45%",
        top: matchesForCharts ? "25%" : "0%",
        // bottom:"0%",
        label: {
          show: false,
          position: "center",
          // position: 'inner',
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 14,
            width: 100,
            overflow: "break",
            fontWeight: "bold",
            color: chartTextColor,
          },
        },
        labelLine: {
          show: false,
        },
        data: getPaiChartData(),
      },
    ],
  };

  const barChartData = {
    labels,
    datasets: [
      {
        label: "Amount",
        data: dashboardData?.saleChart?.chartData,
      },
    ],
  };
  const base64 = invoiceHtml;
  const pdfContentType = "application/pdf";
  function getPaiChartData() {
    const paiChartData: any = [];
    if (dashboardData !== null && dashboardData !== undefined) {
      if (
        dashboardData?.soldItemChart.chartData !== null &&
        dashboardData?.soldItemChart.chartLabels !== null &&
        dashboardData?.soldItemChart.chartQuantity !== null
      )
        for (
          var i = 0;
          i < dashboardData?.soldItemChart.chartData.length;
          i++
        ) {
          // var long: any = dashboardData?.soldItemChart.chartLabels[i];
          // var short: any = long.replace(/(.{20})..+/, "$1…");
          var data = {
            value: dashboardData?.soldItemChart.chartData[i],
            name: dashboardData?.soldItemChart.chartLabels[i],
            qty: dashboardData?.soldItemChart.chartQuantity[i],
          };
          paiChartData.push(data);
        }
    }
    return paiChartData;
  }
  const base64toBlob = (data: string) => {
    // Cut the prefix `data:application/pdf;base64` from the raw base 64
    const base64WithoutPrefix = data.substr(
      `data:${pdfContentType};base64,`.length,
    );
    const bytes = atob(base64WithoutPrefix);
    let length = bytes.length;
    let out = new Uint8Array(length);
    while (length--) {
      out[length] = bytes.charCodeAt(length);
    }
    return new Blob([out], { type: pdfContentType });
  };
  const url = URL.createObjectURL(base64toBlob(base64));

  async function fetchDashboardlist() {
    try {
      if (
        userContext != null &&
        userContext.consumerId != null &&
        userContext.consumerId > 0
      ) {
        setAllowAdd(true);
      } else {
        setAllowAdd(false);
      }
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("firmId", userContext.firmId.toString());
      if (userContext.enableCompositionTax === true) {
        params.append("saleTypeId", "102"); //composition
      } else {
        params.append("saleTypeId", "1"); //gst
      }
      params.append(
        "startDate",
        format(new Date(selectedDateRange[0].startDate), "yyyy-MM-dd"),
      );
      params.append(
        "endDate",
        format(new Date(selectedDateRange[0].endDate), "yyyy-MM-dd"),
      );
      params.append("financialYear", userContext.financialYear?.toString());
      params.append("rowManagedBy", userContext.userId.toString());
      const result: any = await GetDashboard(params);
      if (result && result.data.data) {
        setDashboardData(result.data.data);
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  const onClickCreatePurchase = (e: any) => {
    let encSaleId: any = edService.encrypt(0);
    e.preventDefault();
    navigate(
      {
        pathname: "/purchase-save",
        search: `?q=${encodeURIComponent(encSaleId)}`,
      },
      {
        state: {
          fromPathName: "/purchase",
          fromSearch: "page=1&q=",
        },
      },
    );
  };

  async function deleteRow(saleid: any) {
    try {
      let DeleteData = {
        ids: saleid.toString(),
        isDeleted: true,
        dataManagedBy: userContext.userId,
      };
      const result: any = await DeleteSale(DeleteData);
      if (result) {
        fetchSaleList();
        setAnchorEl3(null);
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: result.message,
          alertType: AlertType.Success,
        });
      } else {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: result.message,
          alertType: AlertType.Success,
        });
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: e
          ? typeof e === "string"
            ? (e as string)
            : (e?.message as string)
          : "Something went wrong.",
        alertType: AlertType.Error,
      });
    }
    setopenDilog(false);
  }
  const saleListSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = resultData.saleCollection.map((n: any) => n.saleId);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const onClickCreateInvoice = (e: any) => {
    let encSaleId: any = edService.encrypt(0);
    e?.preventDefault();
    if (userContext.enableCompositionTax === true) {
      navigate(
        {
          pathname: "/invoice-save",
          search: `?q=${encodeURIComponent(encSaleId)}&t=composition-invoice`,
        },
        {
          state: {
            ...stateInvoice,
            fromPathName: "/invoice",
            fromSearch: "t=composition-invoice&page=1&q=",
          },
        },
      );
    } else {
      navigate(
        {
          pathname: "/invoice-save",
          search: `?q=${encodeURIComponent(encSaleId)}&t=tax-invoice`,
        },
        {
          state: {
            ...stateInvoice,
            fromPathName: "/invoice",
            fromSearch: "t=tax-invoice&page=1&q=",
          },
        },
      );
    }
  };

  const viewAllInvoice = () => {
    if (userContext.enableCompositionTax === true) {
      navigate({
        pathname: "/invoice",
        search: `?t=composition-invoice&page=1&q=`,
      });
    } else {
      navigate({
        pathname: "/invoice",
        search: `?t=tax-invoice&page=1&q=`,
      });
    }
  };

  const viewAllDocument = () => {
    navigate({
      pathname: "/documents",
      search: `?t=all`,
    });
  };

  const handleClickOpen = () => {
    setopenDilog(true);
  };

  async function saleEdit(saleid: any) {
    try {
      let encSaleId: any = edService.encrypt(saleid);
      let curSaleType = ``;
      let convertedSq: any = edService.encrypt(0);
      if (userContext.enableCompositionTax === false) {
        curSaleType = `tax-invoice`;
        navigate(
          {
            pathname: "/invoice-save",
            search: `?q=${encodeURIComponent(encSaleId)}&t=${curSaleType}`,
          },
          {
            state: {
              title: " Edit Invoice",
              button: "Update",
              saleId: saleid,
              fromPathName: "/invoice",
              fromSearch: "t=tax-invoice&page=1&q=",
            },
          },
        );
      } else {
        curSaleType = `composition-invoice`;
        navigate(
          {
            pathname: "/invoice-save",
            search: `?q=${encodeURIComponent(encSaleId)}&t=${curSaleType}`,
          },
          {
            state: {
              title: " Edit Invoice",
              button: "Update",
              saleId: saleid,
              fromPathName: "/invoice",
              fromSearch: "t=composition-invoice&page=1&q=",
            },
          },
        );
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  async function openInvoicePopupPrint(id: number) {
    try {
      //setLoading(true);
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("saleId", id.toString());
      params.append("financialYear", userContext.financialYear?.toString());
      const result: any = await GetPrintInvoice(params);
      if (result && result.data && result.data.data) {
        setInvoiceHtmlDownload(result.data.data);
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  function openPrintInvoiceReportDownload(
    scrollType: DialogProps["scroll"],
    id: number,
    saleNumber: string,
    buyerName: string,
  ) {
    setLoading(true);
    openInvoicePopupPrint(id).then(() => {
      setopenInvoiceDownload(true);
      document.title = saleNumber.toString() + "-" + buyerName;
      setLoading(false);
    });
    setLoading(false);
  }

  const handleCloseInvoiceReportSeelctionDialogBox = (val: any) => {
    setInvoiceReportSelectionDialog(false);
  };

  const handleListItemInvoiceTemplateClick = async (item: any) => {
    setInvoiceReportSelectionDialog(false);
    setReportName(item);
    getDefaultInvoice();
    if (item?.startsWith("TransportInvoice")) {
      await handleOpenTransportInvoice(itemData?.saleId || dialogSaleData?.saleId);
      setInvoiceName("SALE");
      setOpeninvoice(true);
    } else {
      openInvoicePopup(itemData?.saleId, 0, item).then(() => {
        setLoading(true);
        setOpeninvoice(true);
        setLoading(false);
      });
    }
  };

  const handlePrintEwayBillDriverCopy = async (
    eWayBillId: any,
    eWayBillNo: any,
    isDownload: number,
  ) => {
    try {
      setLoading(true);
      setAnchorEl3(null);
      let params = new URLSearchParams();
      let fileData: any;
      let downloadPdfTitle =
        "EWayBillDriverCopy" +
        "_" +
        dialogSaleData.saleNumber?.toString() +
        ".pdf";
      params.append("reportName", "E-WayBillDriverCopy");
      params.append("reportType", "pdf");
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("consumerId", userContext.consumerId.toString());
      params.append("eWayBillId", eWayBillId.toString());
      params.append("eWayBillNo", eWayBillNo.toString());
      params.append("fileName", downloadPdfTitle);
      params.append("isForDownload", isDownload?.toString());
      let result: any;
      result = await GetEWayBillDriverCopy(params);
      if (result && result.data.data) {
        fileData = result?.data?.data.fileData;
        if (isDownload === 1) {
          ExportFilesFunction(downloadPdfTitle, "pdf", fileData);
          setLoading(false);
        } else {
          setLoading(false);
          const linkSource = `data:application/pdf;base64,${fileData}`;
          setInvoiceHtml(linkSource);
        }
      }
      setLoading(false);
      return fileData;
    } catch (e: any) {
      setLoading(false);
      return false;
    }
  };

  const EwayBillActions = [
    {
      label: "Update E-Way Bill",
      value: "UP",
    },
    {
      label: "Cancel E-Way Bill",
      value: "CA",
    },
    // {
    //   label: "Reject",
    //   value: "RE",
    // },
    {
      label: "Extend E-Way Bill",
      value: "EX",
    },
    {
      label: "Update Transporter E-Way Bill",
      value: "UT",
    },
    // {
    //   label: "Consolidate",
    //   value: "CO",
    // },
  ];

  const handleEWayBillAction = async (action: string) => {
    try {
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId?.toString());
      params.append("firmId", userContext.firmId?.toString());
      params.append("branchId", userContext.branchId?.toString());
      const userNameAndPassWordExists: any =
        await CheckUserNameAndPasswordIsExist(params);
      if (userNameAndPassWordExists && userNameAndPassWordExists.data) {
        if (userNameAndPassWordExists.data.data) {
          setEWayBillUpdate({
            open: true,
            eWayBillId: dialogSaleData.eWayBillId,
            type: action,
          });
          if (action === "UP") {
            let encSaleId: any = edService.encrypt(saleId);
            let encEWayBillId: any = edService.encrypt(
              dialogSaleData.eWayBillId,
            );
            navigate({
              pathname: "/e-way-bill-update",
              search: `?q=${encodeURIComponent(
                encSaleId,
              )}&t=${"tax-invoice"}&e=${encodeURIComponent(encEWayBillId)}`,
            });
          } else if (action === "EX") {
            let encSaleId: any = edService.encrypt(saleId);
            let encEWayBillId: any = edService.encrypt(
              dialogSaleData.eWayBillId,
            );
            navigate({
              pathname: "/e-way-bill-extend",
              search: `?q=${encodeURIComponent(
                encSaleId,
              )}&t=${"tax-invoice"}&e=${encodeURIComponent(encEWayBillId)}`,
            });
          }
        } else {
          updateUserContext({
            ...userContext,
            isAlert: true,
            alertMessage:
              "Can't find user name or password please update it in selected Branch.",
            alertType: AlertType.Error,
          });
        }
      } else {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: "Something Went Wrong.",
          alertType: AlertType.Error,
        });
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: e
          ? typeof e === "string"
            ? (e as string)
            : (e?.message as string)
          : "Something went wrong.",
        alertType: AlertType.Error,
      });
    }
  };

  const handleEwayBillPopUp = (value: boolean) => {
    setEWayBillUpdate({ open: value, eWayBillId: 0, type: "" });
  };

  const handleRejectEWayBill = async () => {
    try {
      let rejectEWayBill = {
        consumerId: userContext.consumerId,
        branchId: userContext.branchId,
        firmId: userContext.firmId,
        rowManagedBy: userContext.userId,
        eWayBillId: dialogSaleData.eWayBillId,
        eWayBillNo: dialogSaleData.eWayBillNo,
        tableName: "SALE",
        linkId: dialogSaleData.saleId,
      };
      const resultCancelEWayBill: any = await RejectEWayBill(rejectEWayBill);
      if (resultCancelEWayBill.data === true) {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: resultCancelEWayBill.message,
          alertType: AlertType.Success,
        });
        setEWayBillUpdate({ open: false, eWayBillId: 0, type: "" });
      } else {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: resultCancelEWayBill.message,
          alertType: AlertType.Error,
        });
        setEWayBillUpdate({ open: false, eWayBillId: 0, type: "" });
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
      setEWayBillUpdate({ open: false, eWayBillId: 0, type: "" });
    }
  };

  const handlePrintEwayBillOriginalCopy = async (
    eWayBillId: any,
    eWayBillNo: any,
    isDownload: number,
  ) => {
    try {
      setLoading(true);
      setAnchorEl3(null);
      let params = new URLSearchParams();
      let fileData: any;
      let downloadPdfTitle =
        "EWayBillOriginalCopy" +
        "_" +
        dialogSaleData.saleNumber?.toString() +
        ".pdf";
      params.append("reportName", "E-WayBillOriginalCopy");
      params.append("reportType", "pdf");
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("consumerId", userContext.consumerId.toString());
      params.append("eWayBillId", eWayBillId.toString());
      params.append("eWayBillNo", eWayBillNo.toString());
      params.append("fileName", downloadPdfTitle);
      params.append("isForDownload", isDownload?.toString());
      let result: any;
      result = await GetEWayBillOriginalCopy(params);
      if (result && result.data.data) {
        fileData = result?.data?.data.fileData;
        if (isDownload === 1) {
          ExportFilesFunction(downloadPdfTitle, "pdf", fileData);
          setLoading(false);
        } else {
          setLoading(false);
          const linkSource = `data:application/pdf;base64,${fileData}`;
          setInvoiceHtml(linkSource);
        }
      }
      setLoading(false);
      return fileData;
    } catch (e: any) {
      setLoading(false);
      return false;
    }
  };

  const handleOpenTransportInvoice = async (id: number) => {
    setLoading(true);
    try {
      let params = new URLSearchParams();
      params.append("saleId", id.toString());
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());

      const startDateStr = format(selectedDateRange[0].startDate, "yyyy-MM-dd");
      const endDateStr = format(selectedDateRange[0].endDate, "yyyy-MM-dd");
      params.append("startDate", startDateStr);
      params.append("endDate", endDateStr);
      params.append("financialYear", userContext.financialYear?.toString() || "");

      const result: any = await GetTransportInvoiceReport(params);
      if (result?.data?.data) {
        setTransportInvoiceData(result.data.data);
      } else if (result?.data) {
        setTransportInvoiceData(result.data);
      } else {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: "Failed to fetch transport invoice data",
          alertType: AlertType.Error,
        });
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    } finally {
      setLoading(false);
    }
  };

  async function handleClickOpeninvoice(
    scrollType: DialogProps["scroll"],
    id: any,
    item: any,
    isDownload: any,
    type: string,
  ) {
    if (item !== null) setItemData(item);
    setDialogSaleData(item);
    setInvoiceName(type);
    setAnchorEl3(null);
    if (type === "SALE") {
      let pdfname =
        item?.saleNumber +
        (item.buyerName ? " - " + item?.buyerName : "") +
        ".pdf";
      setInvoiceTitle(pdfname);
      if (defaultinvoiceNameObj?.startsWith("TransportInvoice")) {
        setReportName(defaultinvoiceNameObj);
        await handleOpenTransportInvoice(id);
        setInvoiceName(type);
        if (isDownload === 0) {
          setOpeninvoice(true);
          setScroll(scrollType);
        }
      } else {
        openInvoicePopup(id, isDownload, defaultinvoiceNameObj).then(() => {
          if (isDownload === 0) {
            setLoading(true);
            setOpeninvoice(true);
            setScroll(scrollType);
            setLoading(false);
          } else {
          }
        });
      }
    } else if (type === "EINVOICE") {
      let pdfname =
        item?.saleNumber +
        (item.buyerName ? " - " + item?.buyerName : "") +
        "-e-invoice.pdf";
      setInvoiceTitle(pdfname);
      handlePrintEInvoiceCopy(id, isDownload).then(() => {
        if (isDownload === 0) {
          setLoading(true);
          setOpeninvoice(true);
          setScroll(scrollType);
          setLoading(false);
        } else {
        }
      });
    } else if (type === "EWAYBILLORIGINAL") {
      let pdfname =
        item?.saleNumber +
        (item.buyerName ? " - " + item?.buyerName : "") +
        "-e-waybill.pdf";
      setInvoiceTitle(pdfname);
      handlePrintEwayBillOriginalCopy(
        item?.eWayBillId,
        item?.eWayBillNo,
        isDownload,
      ).then(() => {
        if (isDownload === 0) {
          setLoading(true);
          setOpeninvoice(true);
          setScroll(scrollType);
          setLoading(false);
        } else {
        }
      });
    } else if (type === "EWAYBILLDRIVERCOPY") {
      let pdfname =
        item?.saleNumber +
        (item.buyerName ? " - " + item?.buyerName : "") +
        "-e-waybill-driver-copy.pdf";
      setInvoiceTitle(pdfname);
      handlePrintEwayBillDriverCopy(
        item?.eWayBillId,
        item?.eWayBillNo,
        isDownload,
      ).then(() => {
        if (isDownload === 0) {
          setLoading(true);
          setOpeninvoice(true);
          setScroll(scrollType);
          setLoading(false);
        } else {
        }
      });
    }
  }

  async function openInvoicePopup(
  id: number,
  isDownload: number,
  templateNameFor: any,
) {
  try {
    setLoading(true);

    const eWayBill = resultData?.saleCollection?.find(
      (x: any) => x.saleId === id,
    );

    let downloadPdfTitle =
      itemData?.saleNumber +
      (itemData?.buyerName ? " - " + itemData?.buyerName : "") +
      ".pdf";

    // ============================================================
    // HTML-based templates — these have their OWN dedicated endpoints
    // ============================================================
    const htmlTemplateApis: Record<
      string,
      (p: URLSearchParams) => Promise<any>
    > = {
      TaxInvoiceA4: GetPrintInvoiceHtml,
      TaxInvoiceA4WithRightSideLogo: GetTaxInvoiceHtmlWithRightSideLogo,
    };

    const htmlApi = htmlTemplateApis[templateNameFor];

    if (htmlApi) {
      const htmlParams = new URLSearchParams();
      htmlParams.append("firmId", userContext.firmId.toString());
      htmlParams.append("branchId", userContext.branchId.toString());
      htmlParams.append("consumerId", userContext.consumerId.toString());
      htmlParams.append("saleId", id.toString());

      const htmlResult = await htmlApi(htmlParams);
      const fileData = htmlResult?.data?.data?.fileData;

      if (fileData) {
        const linkSource = `data:application/pdf;base64,${fileData}`;
        setFileToken("");
        setInvoiceHtml(linkSource);

        if (isDownload === 1) {
          ExportFilesFunction(downloadPdfTitle, "pdf", fileData);
        }
      }

      setLoading(false);
      return {
        attachedFile: fileData
          ? `data:application/pdf;base64,${fileData}`
          : "",
        fileName: downloadPdfTitle,
        mimeType: "application/pdf",
      };
    }

    // ============================================================
    // All other templates go through the generic landscape endpoint
    // with reportName = templateNameFor. The backend switches the
    // template based on reportName.
    // ============================================================
    let params = new URLSearchParams();
    params.append("reportName", templateNameFor || "PrintInvoice");
    params.append("saleId", id.toString());
    params.append("reportType", "pdf");
    params.append("consumerId", userContext.consumerId.toString());
    params.append("branchId", userContext.branchId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("fileName", downloadPdfTitle);
    params.append("isForDownload", isDownload?.toString());
    params.append("financialYear", userContext.financialYear?.toString());

    if (templateNameFor === "PrintInvoiceMain") {
      params.append("eWayBillId", eWayBill?.eWayBillId?.toString() || "0");
      params.append("eWayBillNo", eWayBill?.eWayBillNo || "");
    }

    setInvoiceHtmlTitle(
      userContext.enableCompositionTax === false
        ? "Tax Invoice"
        : "Composition Invoice",
    );

    let result: any;

    // Consumer 32 has dedicated LWH endpoints
    if (userContext.consumerId === 32) {
      if (templateNameFor === "PrintInvoiceLWH_2") {
        // "Normal" variant for consumer 32 — falls back to generic endpoint
        result = await GetLandScapePrintInvoiceReport(params);
      } else {
        result = await GetLWHPrintInvoiceReport(params);
      }
    } else if (templateNameFor === "PrintInvoiceMain") {
      result = await GeneratePrintInvoiceEWayBill(params);
    } else {
      // Everything else: Pharma Wholesale A4/A5, Courier, A5, Landscape,
      // Format2, InlineGst, etc. — backend picks template via reportName
      result = await GetLandScapePrintInvoiceReport(params);
    }

    let linkSource: any;
    if (result?.data?.data?.fileData) {
      const fileData = result.data.data.fileData;
      setFileToken(result?.data?.data?.fileToken || "");

      if (isDownload === 0) {
        linkSource = `data:application/pdf;base64,${fileData}`;
        setInvoiceHtml(linkSource);
      } else {
        ExportFilesFunction(downloadPdfTitle, "pdf", fileData);
      }
    }

    setLoading(false);
    return {
      attachedFile: linkSource,
      fileName: downloadPdfTitle,
      mimeType: "application/pdf",
    };
  } catch (error: any) {
    console.error("openInvoicePopup error:", error);
    setLoading(false);
    updateUserContext({
      ...userContext,
      isAlert: true,
      alertMessage: "Something went wrong",
      alertType: AlertType.Error,
    });
  }
}
  const descriptionElementRef = React.useRef<HTMLElement>(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const isCloseSendEmail = () => {
    setIsOpen(false);
  };

  function handleClickOpenSendEmail(isOpen: boolean, item: any) {
    setItemData(item);
    let pdfname = item?.saleNumber + ".pdf";
    setPdfFileName(pdfname);
    setIsOpen(isOpen);
    setAnchorEl3(null);
    setDataId(item?.saleId);
    setFinalTotalAmount(item.finalGrandTotal);
    setUserName(item?.buyerName);
    setReportName(
      reportName !== "" ? reportName : defaultinvoiceNameObj || "PrintInvoice",
    );
    if (userContext.enableCompositionTax) {
      setInvoiceHtmlTitle("Composition Invoice");
    } else {
      setInvoiceHtmlTitle("Tax Invoice");
    }
  }

  async function fetchSaleList() {
    const start = Date.now();
    setIsInvoiceListLoading(true);
    try {
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append(
        "startDate",
        format(new Date(selectedDateRange[0].startDate), "yyyy-MM-dd"),
      );
      params.append(
        "endDate",
        format(new Date(selectedDateRange[0].endDate), "yyyy-MM-dd"),
      );
      params.append("pageIndex", page_Index.toString());
      params.append("pageSize", param.pageSize);
      params.append("sortColumn", param.sortColumn);
      params.append("sortDirection", param.sortDirection);
      params.append("searchValue", param.searchValue);
      params.append("financialYear", userContext.financialYear?.toString());
      const result: any = await GetSaleList(params);
      if (result && result.data.data) {
        let dataCount = result.data.data.totalCount;
        let SaleInfo = result.data.data;
        setResultData(SaleInfo);
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    } finally {
      const remaining = Math.max(0, 250 - (Date.now() - start));
      if (remaining > 0) {
        await new Promise((r) => setTimeout(r, remaining));
      }
      setIsInvoiceListLoading(false);
    }
  }

  const isDateInLastMonth = (dateString: string): boolean => {
    try {
      const parsedDate = new Date(dateString);
      if (isNaN(parsedDate.getTime())) {
        console.error("Invalid date:", dateString);
        return false;
      }

      const dateOnly = startOfDay(parsedDate);
      const today = startOfDay(new Date());
      const thirtyDaysFromNow = new Date(today);
      thirtyDaysFromNow.setDate(today.getDate() + 30);

      return isWithinInterval(dateOnly, {
        start: today,
        end: thirtyDaysFromNow,
      });
    } catch (error) {
      console.error("Date comparison error:", error);
      return false;
    }
  };

  const isDateInNextTwoMonths = (dateString: string): boolean => {
    if (!dateString) return false;

    try {
      const parsedDate = new Date(dateString);
      if (isNaN(parsedDate.getTime())) {
        console.error("Invalid date:", dateString);
        return false;
      }

      const dateOnly = startOfDay(parsedDate);
      const today = startOfDay(new Date());
      const thirtyDaysFromNow = new Date(today);
      thirtyDaysFromNow.setDate(today.getDate() + 30);

      const sixtyDaysFromNow = new Date(today);
      sixtyDaysFromNow.setDate(today.getDate() + 60);

      return isWithinInterval(dateOnly, {
        start: thirtyDaysFromNow,
        end: sixtyDaysFromNow,
      });
    } catch (error) {
      console.error("Date comparison error:", error);
      return false;
    }
  };

  async function handleEditDocument(
    documentId: any,
    fullName: string,
    pageType: string,
  ) {
    try {
      let encDocumentId: any = edService.encrypt(documentId);
      navigate(
        {
          pathname: "/document-save",
          search: `?q=${encodeURIComponent(encDocumentId)}&t=${pageType}`,
        },
        {
          state: {
            title: " Edit Document",
            button: "Update",
            documentIdId: documentId,
            isAddPopUp: "false",
            fullname: fullName,
          },
        },
      );
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  async function fetchDocumentList() {
    const start = Date.now();
    setIsDocumentLoading(true);
    try {
      if (
        userContext != null &&
        userContext.consumerId != null &&
        userContext.consumerId > 0
      ) {
        setAllowAdd(true);
      } else {
        setAllowAdd(false);
      }
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId.toString());
      params.append("linkId", "0");
      params.append("tableName", "");
      params.append("pageType", "");
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("pageIndex", page_Index.toString());
      params.append("pageSize", param.pageSize);
      params.append("sortColumn", param.sortColumn);
      params.append("sortDirection", param.sortDirection);
      params.append("searchValue", param.searchValue);
      params.append("mode", "");
      params.append("type", "NEAR_EXPIRED");
      const result: any = await GetDocumentList(params);
      if (result && result.data.data) {
        let dataCount = result.data.data.totalCount;
        let vehicleInfo = result.data.data;
        setDocumentData(vehicleInfo);
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    } finally {
      const remaining = Math.max(0, 250 - (Date.now() - start));
      if (remaining > 0) {
        await new Promise((r) => setTimeout(r, remaining));
      }
      setIsDocumentLoading(false);
    }
  }

  const handleCloseD = () => {
    setAnchorEl3(null);
  };

  const getDefaultInvoice = async () => {
    let params = new URLSearchParams();
    params.append("consumerId", userContext.consumerId.toString());
    params.append("userId", userContext.userId.toString());
    let editDetails: any;
    try {
      const result: any = await GetUserDetail(params);
      if (result && result.data && result.data.data) {
        editDetails = result?.data?.data;
        setDefaultinvoiceNameObj(editDetails?.defaultInvoice);
      } else {
      }
    } catch (error) {
      console.log("you are login as superadmin move to admin ");
    }
    return editDetails;
  };

  const handleDateRange = (selected: any, popupState) => {
    // Your logic here
    const calenderHeading =
      format(new Date(selected[0].startDate), "dd-MM-yyyy") +
      " To " +
      format(new Date(selected[0].endDate), "dd-MM-yyyy");
    setDateRange(selected);
    setDateHeading(calenderHeading);
    popupState.close();
  };

  const handleOpenInvoiceReportSeelctionDialogBox = (item) => {
    if (item !== null) setItemData(item);
    setInvoiceName("SALE");
    setInvoiceReportSelectionDialog(true);
    setAnchorEl3(null);
    let pdfname =
      item?.saleNumber +
      (item.buyerName ? " - " + item?.buyerName : "") +
      ".pdf";
    setInvoiceTitle(pdfname);
  };

  let summaryEstGST = dashboardData
    ? dashboardData.gstPurchaseAmount - dashboardData.gstSaleAmount
    : 0;
  let summaryEstRevenue = dashboardData
    ? dashboardData.saleAmount - dashboardData.purchaseAmount
    : 0;
  let summarySaleAmount = dashboardData ? dashboardData.saleAmount : 0;
  let summaryPurchaseAmount = dashboardData ? dashboardData.purchaseAmount : 0;
  let summaryGSTSaleAmount = dashboardData ? dashboardData.gstSaleAmount : 0;
  let summaryGSTPurchaseAmount = dashboardData
    ? dashboardData.gstPurchaseAmount
    : 0;
  const StyledMenu = styled((props: MenuProps) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      {...props}
    />
  ))(({ theme }) => ({
    "& .MuiPaper-root": {
      borderRadius: "10px !important",
      marginTop: theme.spacing(1),
      minWidth: 250,
      color:
        theme.palette.mode === "light"
          ? "rgb(55, 65, 81)"
          : theme.palette.grey[300],
      boxShadow:
        "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px !important",
      "& .MuiMenu-list": {
        padding: "4px 0",
      },
      "& .MuiMenuItem-root": {
        "& .MuiSvgIcon-root": {
          fontSize: 18,
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(1.5),
        },
        "&:active": {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  }));

  const handlePrintEInvoiceCopy = async (saleId, isDownload) => {
    try {
      setLoading(true);
      setAnchorEl3(null);
      let params = new URLSearchParams();
      let fileData: any;
      let downloadPdfTitle =
        "EInvoice" + "_" + dialogSaleData.saleNumber?.toString() + ".pdf";
      params.append("reportName", "PrintEInvoice");
      params.append("reportType", "pdf");
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("consumerId", userContext.consumerId.toString());
      params.append("saleId", saleId.toString());
      params.append("fileName", downloadPdfTitle);
      params.append("isForDownload", isDownload?.toString());
      let result: any;
      result = await GetLandScapePrintInvoiceReport(params);
      if (result && result.data.data) {
        fileData = result?.data?.data.fileData;
        if (isDownload) {
          ExportFilesFunction(downloadPdfTitle, "pdf", fileData);
          setLoading(false);
        } else {
          setLoading(false);
          const linkSource = `data:application/pdf;base64,${fileData}`;
          setInvoiceHtml(linkSource);
        }
      }
      setLoading(false);
      return fileData;
    } catch (e: any) {
      setLoading(false);
      return false;
    }
  };

  const GenerateEWayBill = async (saleId: any, saleTypeId: any) => {
    setAnchorEl3(null);
    try {
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId?.toString());
      params.append("firmId", userContext.firmId?.toString());
      params.append("branchId", userContext.branchId?.toString());
      const userNameAndPassWordExists: any =
        await CheckUserNameAndPasswordIsExist(params);
      if (userNameAndPassWordExists && userNameAndPassWordExists.data) {
        if (userNameAndPassWordExists.data.data) {
          if (saleId > 0) {
            let encSaleId: any = edService.encrypt(saleId);
            navigate({
              pathname: "/e-way-bill",
              search: `?q=${encodeURIComponent(encSaleId)}&t=${saleTypeId}`,
            });
          }
        } else {
          updateUserContext({
            ...userContext,
            isAlert: true,
            alertMessage:
              "Can't find user name or password please update it in selected Branch.",
            alertType: AlertType.Error,
          });
        }
      } else {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: "Something Went Wrong.",
          alertType: AlertType.Error,
        });
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: e
          ? typeof e === "string"
            ? (e as string)
            : (e?.message as string)
          : "Something went wrong.",
        alertType: AlertType.Error,
      });
    }
  };
  const edService = new EncryptDecryptService();

  const handleNavigation = (code, item: any) => {
    if (!item) return;
    let path = "";
    let state = {};
    if (code === "CASH_IN_HAND") {
      path = `/ledger-group-summary?q=${encodeURIComponent(
        edService.encrypt(item?.ledgerAccountName || ""),
      )}`;
      // state = {
      //   startDate: format(
      //     new Date(selectedDateRange[0].startDate),
      //     "yyyy-MM-dd"
      //   ),
      //   endDate: format(new Date(selectedDateRange[0].endDate), "yyyy-MM-dd"),
      // };
    } else if (code === "BANK_ACCOUNT") {
      path = `/ledger-group-summary?q=${encodeURIComponent(
        edService.encrypt(item?.ledgerAccountName || ""),
      )}`;
      // state = {
      //   startDate: format(
      //     new Date(selectedDateRange[0].startDate),
      //     "yyyy-MM-dd"
      //   ),
      //   endDate: format(new Date(selectedDateRange[0].endDate), "yyyy-MM-dd"),
      // };
    } else if (code === "OUTSTANDING_RECEIVABLES") {
      path = `/outstanding-receivable-new`;
    } else if (code === "OUTSTANDING_PAYABLES") {
      path = `/outstanding-payable-new`;
    }

    navigate(path, { state: { ...state } });
  };

  const fetchData = async () => {
    const loadDashboard = async () => {
      const start = Date.now();
      setIsDashboardLoading(true);
      try {
        await fetchDashboardlist();
      } finally {
        const remaining = Math.max(0, 250 - (Date.now() - start));
        if (remaining > 0) {
          await new Promise((r) => setTimeout(r, remaining));
        }
        setIsDashboardLoading(false);
      }
    };

    await Promise.allSettled([
      loadDashboard(),
      fetchSaleList(),
      fetchDocumentList(),
    ]);
  };

  useEffect(() => {
    setIsCustomDate(false);
    setAnchorEl4(null);
    fetchData();
  }, [selectedDateRange, param]);

  useEffect(() => {
    getDefaultInvoice();
  }, []);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const isModifierPressed = event.altKey || event.metaKey;
      if (!isModifierPressed) {
        return;
      }

      const code = event.code;
      if (code === "KeyI") {
        event.preventDefault();
        onClickCreateInvoice({ preventDefault: () => {} });
      } else if (code === "KeyP") {
        event.preventDefault();
        onClickCreatePurchase({ preventDefault: () => {} });
      }
    };

    window.addEventListener("keydown", handleKeyDown, { capture: true });
    return () => {
      window.removeEventListener("keydown", handleKeyDown, { capture: true });
    };
  }, [onClickCreateInvoice, onClickCreatePurchase]);

  return (
    <>
      <Title pageTitle="Dashboard" />
      {userContext.userRole === "user" ? (
        <>
          {matches ? (
            <>
              <h5 className="page-dashboard">
                Welcome back{" "}
                {userContext.firstName + " " + userContext.lastName}!
              </h5>
              <Grid
                style={{
                  //  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: 20,
                  marginLeft: 10,
                  marginRight: 10,
                }}
              >
                <Grid>
                  <Button
                    className="dashboard-button-responsive"
                    variant="contained"
                    onClick={onClickCreateInvoice}
                    startIcon={matchesForInvoice ? <AddIcon /> : undefined}
                    style={{ backgroundColor: "#25258f", color: "white" }}
                  >
                    Create Invoice
                  </Button>
                </Grid>
                <Grid>
                  <Button
                    className="dashboard-button-responsive"
                    variant="contained"
                    onClick={onClickCreatePurchase}
                    startIcon={matchesForInvoice ? <AddIcon /> : undefined}
                    style={{ backgroundColor: "#25258f", color: "white" }}
                  >
                    Create Purchase
                  </Button>
                </Grid>
              </Grid>
            </>
          ) : (
            <>
              <div className="page-dashboard">
                <h2>
                  Welcome, {userContext.firstName + " " + userContext.lastName}!
                </h2>
              </div>
              <Grid
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: 20,
                }}
              >
                <Button
                  className="dashboard-button-responsive"
                  variant="contained"
                  onClick={onClickCreateInvoice}
                  startIcon={matchesForInvoice ? <AddIcon /> : undefined}
                  style={{ backgroundColor: "#25258f", color: "white" }}
                >
                  Create Invoice
                </Button>
                <Grid className="dashboard-button-grid">
                  <Button
                    className="dashboard-button-responsive"
                    variant="contained"
                    onClick={onClickCreatePurchase}
                    startIcon={matchesForInvoice ? <AddIcon /> : undefined}
                    style={{ backgroundColor: "#25258f", color: "white" }}
                  >
                    Create Purchase
                  </Button>
                </Grid>
              </Grid>
            </>
          )}
        </>
      ) : (
        <>
          {userContext.consumerId > 0 ? (
            <Box
              className="boxContainer"
              sx={{
                "& > :not(style)": {
                  width: "90%",
                  flexGrow: 1,
                },
              }}
              style={{ marginLeft: 16, marginRight: 16 }}
            >
              <Grid className="title-button-responsive">
                <Grid>
                  <Typography
                    variant="h3"
                    className="dashboard-card-title"
                    fontWeight="bold"
                    style={{
                      fontSize: 18,
                      lineHeight: 1.1,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <span style={{ fontSize: 18 }}>Dashboard</span>
                    {/* <u ><i>
                    {" "} {userContext.firmName}
                  </i> </u> */}
                    {/* </h3> */}
                    <span
                      style={{
                        fontSize: 12,
                        fontWeight: "400",
                        lineHeight: 2.5,
                      }}
                    >
                      Welcome, {userContext.firstName}
                    </span>
                  </Typography>
                </Grid>
                <Grid style={{ marginBottom: "15px" }}>
                  <Button
                    className="button-responsive"
                    variant="outlined"
                    onClick={onClickCreateInvoice}
                    startIcon={
                      matchesForInvoice ? (
                        <AddIcon style={{ color: "white" }} />
                      ) : undefined
                    }
                    style={{ backgroundColor: "#25258f", color: "white" }}
                  >
                    <ShortcutButton label="ALT + I" variant="dark" />
                    {/* <ShortcutButton label="I" variant="dark" /> */}
                    Create Invoice
                  </Button>
                  <Grid className="uppergrid">
                    <Button
                      className="button-responsive"
                      variant="outlined"
                      onClick={onClickCreatePurchase}
                      startIcon={
                        matchesForInvoice ? (
                          <AddIcon style={{ color: "white" }} />
                        ) : undefined
                      }
                      style={{ backgroundColor: "#25258f", color: "white" }}
                    >
                      <ShortcutButton label="ALT + P" variant="dark" />
                      {/* <ShortcutButton label="P" variant="dark" /> */}
                      Create Purchase
                    </Button>
                  </Grid>
                  <div style={{ display: "inline" }}>
                    <Button
                      className="button-responsive"
                      variant="outlined"
                      endIcon={
                        <DateRangeIcon
                          sx={{ color: isDarkMode ? "#818CF8" : undefined }}
                        />
                      }
                      {...bindTrigger(popupState)}
                    >
                      {dateHeading.toString()}
                    </Button>
                    <StyledMenu
                      id="demo-customized-menu"
                      MenuListProps={{
                        "aria-labelledby": "demo-customized-button",
                      }}
                      {...bindMenu(popupState)}
                    >
                      {!isCustomDate && (
                        <>
                          <Grid className="dashboard-date-label">
                            <Typography className="typography-first-child">
                              {dateHeading.toString()}
                            </Typography>
                          </Grid>
                          <Divider sx={{ margin: "0px !important" }} />
                          <MenuItem
                            sx={{ padding: "0px !important" }}
                            onClick={popupState.close}
                          >
                            <ListItemButton
                              selected={selectedIndex === 0}
                              sx={{
                                "&.Mui-selected": {
                                  backgroundColor: "#25258f",
                                  color: "#ffffff",
                                },
                                "&.Mui-focusVisible": {
                                  backgroundColor: "#f1f6fe !important",
                                },
                                ":hover": {
                                  backgroundColor: "#f1f6fe",
                                },
                              }}
                              onClick={(event: any) =>
                                handleListItemClick(event, 0)
                              }
                            >
                              <span>Today</span>
                            </ListItemButton>
                          </MenuItem>
                          <MenuItem
                            sx={{ padding: "0px !important" }}
                            onClick={popupState.close}
                          >
                            <ListItemButton
                              selected={selectedIndex === 1}
                              sx={{
                                "&.Mui-selected": {
                                  backgroundColor: "#25258f",
                                  color: "#ffffff",
                                },
                                "&.Mui-focusVisible": {
                                  backgroundColor: "#f1f6fe !important",
                                },
                                ":hover": {
                                  backgroundColor: "#f1f6fe",
                                },
                              }}
                              onClick={(event: any) =>
                                handleListItemClick(event, 1)
                              }
                            >
                              <span>Yestarday</span>
                            </ListItemButton>
                          </MenuItem>
                          <MenuItem
                            sx={{ padding: "0px !important" }}
                            onClick={popupState.close}
                          >
                            <ListItemButton
                              selected={selectedIndex === 2}
                              sx={{
                                "&.Mui-selected": {
                                  backgroundColor: "#25258f",
                                  color: "#ffffff",
                                },
                                "&.Mui-focusVisible": {
                                  backgroundColor: "#f1f6fe !important",
                                },
                                ":hover": {
                                  backgroundColor: "#f1f6fe",
                                },
                              }}
                              onClick={(event: any) =>
                                handleListItemClick(event, 2)
                              }
                            >
                              <span>Last 15 days</span>
                            </ListItemButton>
                          </MenuItem>
                          <MenuItem
                            sx={{ padding: "0px !important" }}
                            onClick={popupState.close}
                          >
                            <ListItemButton
                              selected={selectedIndex === 3}
                              sx={{
                                "&.Mui-selected": {
                                  backgroundColor: "#25258f",
                                  color: "#ffffff",
                                },
                                "&.Mui-focusVisible": {
                                  backgroundColor: "#f1f6fe !important",
                                },
                                ":hover": {
                                  backgroundColor: "#f1f6fe",
                                },
                              }}
                              onClick={(event: any) =>
                                handleListItemClick(event, 3)
                              }
                            >
                              <span>Last 30 days</span>
                            </ListItemButton>
                          </MenuItem>
                          <MenuItem
                            sx={{ padding: "0px !important" }}
                            onClick={popupState.close}
                          >
                            <ListItemButton
                              selected={selectedIndex === 4}
                              sx={{
                                "&.Mui-selected": {
                                  backgroundColor: "#25258f",
                                  color: "#ffffff",
                                },
                                "&.Mui-focusVisible": {
                                  backgroundColor: "#f1f6fe !important",
                                },
                                ":hover": {
                                  backgroundColor: "#f1f6fe",
                                },
                              }}
                              onClick={(event: any) =>
                                handleListItemClick(event, 4)
                              }
                            >
                              <span>Last 90 days</span>
                            </ListItemButton>
                          </MenuItem>
                          <MenuItem
                            sx={{ padding: "0px !important" }}
                            onClick={popupState.close}
                          >
                            <ListItemButton
                              selected={selectedIndex === 5}
                              sx={{
                                "&.Mui-selected": {
                                  backgroundColor: "#25258f",
                                  color: "#ffffff",
                                },
                                "&.Mui-focusVisible": {
                                  backgroundColor: "#f1f6fe !important",
                                },
                                ":hover": {
                                  backgroundColor: "#f1f6fe",
                                },
                              }}
                              onClick={(event: any) =>
                                handleListItemClick(event, 5)
                              }
                            >
                              <span>This Month</span>
                            </ListItemButton>
                          </MenuItem>
                          <MenuItem
                            sx={{ padding: "0px !important" }}
                            onClick={popupState.close}
                          >
                            <ListItemButton
                              selected={selectedIndex === 6}
                              sx={{
                                "&.Mui-selected": {
                                  backgroundColor: "#25258f",
                                  color: "#ffffff",
                                },
                                "&.Mui-focusVisible": {
                                  backgroundColor: "#f1f6fe !important",
                                },
                                ":hover": {
                                  backgroundColor: "#f1f6fe",
                                },
                              }}
                              onClick={(event: any) =>
                                handleListItemClick(event, 6)
                              }
                            >
                              <span>Privious Month</span>
                            </ListItemButton>
                          </MenuItem>
                          <MenuItem
                            sx={{ padding: "0px !important" }}
                            onClick={popupState.close}
                          >
                            <ListItemButton
                              selected={selectedIndex === 7}
                              sx={{
                                "&.Mui-selected": {
                                  backgroundColor: "#25258f",
                                  color: "#ffffff",
                                },
                                "&.Mui-focusVisible": {
                                  backgroundColor: "#f1f6fe !important",
                                },
                                ":hover": {
                                  backgroundColor: "#f1f6fe",
                                },
                              }}
                              onClick={(event: any) =>
                                handleListItemClick(event, 7)
                              }
                            >
                              <span>Current financial year</span>
                            </ListItemButton>
                          </MenuItem>
                          <Divider sx={{ margin: "0px !important" }} />
                          <MenuItem sx={{ padding: "0px !important" }}>
                            <ListItemButton
                              selected={selectedIndex === 8}
                              sx={{
                                "&.Mui-selected": {
                                  backgroundColor: "#25258f",
                                  color: "#ffffff",
                                },
                                "&.Mui-focusVisible": {
                                  backgroundColor: "#f1f6fe !important",
                                },
                                ":hover": {
                                  backgroundColor: "#f1f6fe",
                                },
                              }}
                              onClick={(event: any) =>
                                handleListItemClick(event, 8)
                              }
                            >
                              <span>Custom...</span>
                            </ListItemButton>
                          </MenuItem>
                        </>
                      )}
                      {isCustomDate && (
                        <DateRange
                          editableDateInputs={true}
                          onChange={(item) =>
                            handleDateRange([item.selection], popupState)
                          }
                          minDate={new Date(userContext.financialYearStartDate)}
                          maxDate={new Date(userContext.financialYearEndDate)}
                          moveRangeOnFirstSelection={false}
                          ranges={selectedDateRange}
                        />
                      )}
                    </StyledMenu>
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4} lg={4} xl={2} sm={6}>
                  <Card className="dashboard-card ">
                    <CardContent>
                      <Grid className="dashboard-card-box">
                        <Grid>
                          <Typography
                            variant="h4"
                            className="dashboard-card-title"
                            fontWeight="bold"
                          >
                            Sale
                          </Typography>
                          {isDashboardLoading ? (
                            <SummaryCardValueSkeleton />
                          ) : (
                            <div className="dashboard-fade-in">
                              <Typography
                                variant="h3"
                                className="dashboard-card-amount card-amount-h3"
                              >
                                <span className="card-amount-h3-span-green">
                                  <NumberFormatWithSymbol
                                    amount={dashboardData?.saleAmount || 0}
                                  />
                                </span>
                                {userContext?.enableCompositionTax === false && (
                                  <span
                                    style={{
                                      paddingTop: "3px",
                                      display: "flex",
                                      gap: "8px",
                                    }}
                                  >
                                    <span>+ GST </span>{" "}
                                    <NumberFormatWithSymbol
                                      amount={dashboardData?.gstSaleAmount || 0}
                                    />
                                  </span>
                                )}
                                <span className="font-size-11">{dateHeading}</span>
                              </Typography>
                            </div>
                          )}
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={4} lg={4} xl={2} sm={6}>
                  <Card className="dashboard-card">
                    <CardContent>
                      <Grid className="dashboard-card-box">
                        <Grid>
                          <Typography
                            variant="h4"
                            className="dashboard-card-title"
                            fontWeight="bold"
                          >
                            Purchase
                          </Typography>
                          {isDashboardLoading ? (
                            <SummaryCardValueSkeleton />
                          ) : (
                            <div className="dashboard-fade-in">
                              <Typography
                                variant="h3"
                                className="dashboard-card-amount card-amount-h3"
                              >
                                <span className="card-amount-h3-span-red">
                                  <NumberFormatWithSymbol
                                    amount={dashboardData?.purchaseAmount || 0}
                                  />
                                </span>
                                {userContext?.enableCompositionTax === false && (
                                  <span
                                    style={{
                                      paddingTop: "3px",
                                      display: "flex",
                                      gap: "8px",
                                    }}
                                  >
                                    <span>+ GST </span>{" "}
                                    <NumberFormatWithSymbol
                                      amount={
                                        dashboardData?.gstPurchaseAmount || 0
                                      }
                                    />
                                  </span>
                                )}{" "}
                                <span className="font-size-11">{dateHeading}</span>
                              </Typography>
                            </div>
                          )}
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={4} lg={4} xl={2} sm={6}>
                  <Card className="dashboard-card dashboard-card-min-height">
                    <CardContent>
                      <Grid className="dashboard-card-box">
                        <Grid>
                          <Typography
                            variant="h4"
                            className="dashboard-card-title"
                            fontWeight="bold"
                          >
                            Income
                          </Typography>
                          {isDashboardLoading ? (
                            <SummaryCardValueSkeleton />
                          ) : (
                            <div className="dashboard-fade-in">
                              <Typography
                                variant="h3"
                                className="dashboard-card-amount card-amount-h3"
                              >
                                <>
                                  <span className="card-amount-h3-span-green">
                                    <NumberFormatWithSymbol
                                      amount={
                                        dashboardData?.incomeTotalAmount || 0
                                      }
                                    />
                                  </span>
                                  {userContext?.enableCompositionTax ===
                                    false && (
                                    <span
                                      style={{
                                        paddingTop: "3px",
                                        display: "flex",
                                        gap: "8px",
                                      }}
                                    >
                                      <span>+ GST </span>{" "}
                                      <NumberFormatWithSymbol
                                        amount={
                                          dashboardData?.incomeTaxTotal || 0
                                        }
                                      />
                                    </span>
                                  )}{" "}
                                  <span className="font-size-11">
                                    {dateHeading}
                                  </span>
                                </>
                              </Typography>
                            </div>
                          )}
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={4} lg={4} xl={2} sm={6}>
                  <Card className="dashboard-card dashboard-card-min-height">
                    <CardContent>
                      <Grid className="dashboard-card-box">
                        <Grid>
                          <Typography
                            variant="h4"
                            className="dashboard-card-title"
                            fontWeight="bold"
                          >
                            Expense
                          </Typography>
                          {isDashboardLoading ? (
                            <SummaryCardValueSkeleton />
                          ) : (
                            <div className="dashboard-fade-in">
                              <Typography
                                variant="h3"
                                className="dashboard-card-amount card-amount-h3"
                              >
                                <span className="card-amount-h3-span-red">
                                  <NumberFormatWithSymbol
                                    amount={
                                      dashboardData?.expenceTotalAmount || 0
                                    }
                                  />
                                </span>
                                {userContext?.enableCompositionTax === false && (
                                  <span style={{ paddingTop: "3px" }}>
                                    + GST{" "}
                                    <NumberFormatWithSymbol
                                      amount={
                                        dashboardData?.expenseTaxTotal || 0
                                      }
                                    />
                                  </span>
                                )}
                                <span className="font-size-11">{dateHeading}</span>
                              </Typography>
                            </div>
                          )}
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                {userContext?.enableCompositionTax === false && (
                  <Grid item xs={12} md={4} lg={4} xl={2} sm={6}>
                    <Card
                      className="dashboard-card page-title dashboard-card-min-height"
                      sx={{
                        height: {
                          md: "100%",
                        },
                      }}
                    >
                      <CardContent>
                        <Grid className="dashboard-card-box">
                          <Grid>
                            <Typography
                              variant="h4"
                              className="dashboard-card-title"
                              fontWeight="bold"
                            >
                              GST Receivable
                            </Typography>
                            {isDashboardLoading ? (
                              <GstCardValueSkeleton />
                            ) : (
                              <div className="dashboard-fade-in">
                                <Typography
                                  variant="h3"
                                  className="dashboard-card-amount card-amount-h3"
                                >
                                  <span className="card-amount-h3-span-green">
                                    <NumberFormatWithSymbol
                                      amount={
                                        dashboardData?.taxReceiveable || 0
                                      }
                                    />
                                  </span>
                                  <span className="font-size-11">
                                    {dateHeading}
                                  </span>
                                </Typography>
                              </div>
                            )}
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                )}
                {userContext?.enableCompositionTax === false && (
                  <Grid item xs={12} md={4} lg={4} xl={2} sm={6}>
                    <Card
                      className="dashboard-card page-title dashboard-card-min-height"
                      sx={{
                        height: {
                          md: "100%",
                        },
                      }}
                    >
                      <CardContent>
                        <Grid className="dashboard-card-box">
                          <Grid>
                            <Typography
                              variant="h4"
                              className="dashboard-card-title"
                              fontWeight="bold"
                            >
                              GST Payable
                            </Typography>
                            {isDashboardLoading ? (
                              <GstCardValueSkeleton />
                            ) : (
                              <div className="dashboard-fade-in">
                                <Typography
                                  variant="h3"
                                  className="dashboard-card-amount card-amount-h3"
                                >
                                  <span className="card-amount-h3-span-red">
                                    <NumberFormatWithSymbol
                                      amount={dashboardData?.taxPayable || 0}
                                    />
                                  </span>
                                  <span className="font-size-11">
                                    {dateHeading}
                                  </span>
                                </Typography>
                              </div>
                            )}
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                )}
              </Grid>
              <Grid container spacing={2} mt={0.3}>
                <Grid item xl={6} lg={6} xs={12} sm={12}>
                  <Card className="dashboard-card">
                    <CardContent
                      sx={{
                        padding: "16px 16px",
                      }}
                    >
                      <Box
                        display={"flex"}
                        sx={{ justifyContent: "space-between" }}
                      >
                        <Box>
                          <Typography
                            variant="h4"
                            className="dashboard-card-title"
                            fontWeight="bold"
                          >
                            Outstanding Receivables
                          </Typography>
                          <Typography>
                            <h5
                              style={{
                                lineHeight: "1",
                                fontSize: "11px",
                                fontWeight: "400",
                              }}
                            >
                              Current Financial Year
                            </h5>
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                          onClick={() => {
                            navigate({
                              pathname: "/outstanding-receivable-new",
                              search: `?sd=${userContext.financialYearStartDate}&ed=${userContext.financialYearEndDate}`,
                            });
                          }}
                          className="blue-link text-link link-cursor bold-600"
                        >
                          VIEW ALL
                        </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                    <Divider />
                    {isDashboardLoading ? (
                      <AgingStripSkeleton />
                    ) : (
                      <div className="dashboard-fade-in">
                    <Grid style={{ paddingLeft: 20, paddingTop: 10 }}>
                      <>
                        <Box>
                          <Typography
                            variant="h3"
                            className="dashboard-card-amount card-amount-h3"
                          >
                            <span className="dashboard-card-title">Total</span>
                            <span className="card-amount-h3-span">
                              <NumberFormatWithSymbol
                                amount={
                                  dashboardData?.outStandingReceivables?.[0]
                                    ?.outstandingReceivableTotalAmount || 0
                                }
                              />
                            </span>
                          </Typography>
                        </Box>
                      </>
                    </Grid>
                    <Grid
                      className="dashboard-bar-chart"
                      style={{
                        paddingLeft: 20,
                        paddingRight: 20,
                        paddingBottom: 20,
                      }}
                    >
                      <Grid
                        item
                        container
                        className="dashboard-aging-strip"
                        sx={{
                          border: "1px solid #e0e0e0",
                          borderRadius: "8px",
                          overflow: "hidden",
                          boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                          marginTop: 1,
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        <Grid item xs={12} sm={6} md={6} xl={2.4}>
                          <Box
                            sx={{
                              flex: 1,
                              textAlign: "left",
                              padding: 2,
                              height: "100%",
                              borderRight: {
                                xs: "none",
                                sm: "1px solid #e0e0e0",
                              },
                              borderBottom: {
                                xs: "1px solid #e0e0e0",
                                xl: "none",
                              },
                            }}
                          >
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: 600, letterSpacing: 1 }}
                              onClick={() =>
                                handleOutstandingReceivablesNavigate("current")
                              }
                              className="blue-link text-link link-cursor bold-600"
                            >
                              Current Due
                            </Typography>
                            <Typography
                              sx={{ fontWeight: 700 }}
                              className="font-size-16"
                            >
                              <NumberFormatWithSymbol
                                amount={
                                  dashboardData?.outStandingReceivables?.[0]
                                    ?.outstandingReceivableCurrentAmount || 0
                                }
                              />
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} xl={2.4}>
                          <Box
                            sx={{
                              flex: 1,
                              textAlign: "left",
                              padding: 2,
                              height: "100%",
                              borderRight: {
                                xs: "none",
                                xl: "1px solid #e0e0e0",
                              },
                              borderBottom: {
                                xs: "1px solid #e0e0e0",
                                xl: "none",
                              },
                            }}
                          >
                            <Typography
                              className="font-size-11"
                              sx={{ letterSpacing: 1 }}
                            >
                              Overdue
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: 600, letterSpacing: 1 }}
                              onClick={() =>
                                handleOutstandingReceivablesNavigate("1to15")
                              }
                              className="blue-link text-link link-cursor bold-600"
                            >
                              1 - 15 Days
                            </Typography>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: 700 }}
                              className="font-size-16 red-color"
                            >
                              <NumberFormatWithSymbol
                                amount={
                                  dashboardData?.outStandingReceivables?.[0]
                                    ?.outstandingReceivable1to15DaysAmount || 0
                                }
                              />
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} xl={2.4}>
                          <Box
                            sx={{
                              flex: 1,
                              textAlign: "left",
                              padding: 2,
                              height: "100%",
                              borderRight: {
                                xs: "none",
                                sm: "1px solid #e0e0e0",
                              },
                              borderBottom: {
                                xs: "1px solid #e0e0e0",
                                xl: "none",
                              },
                            }}
                          >
                            <Typography
                              className="font-size-11"
                              sx={{ letterSpacing: 1 }}
                            >
                              Overdue
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: 600, letterSpacing: 1 }}
                              onClick={() =>
                                handleOutstandingReceivablesNavigate("16to30")
                              }
                              className="blue-link text-link link-cursor bold-600"
                            >
                              16 - 30 Days
                            </Typography>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: 700 }}
                              className="font-size-16 red-color"
                            >
                              <NumberFormatWithSymbol
                                amount={
                                  dashboardData?.outStandingReceivables?.[0]
                                    ?.outstandingReceivable16to30DaysAmount || 0
                                }
                              />
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} xl={2.4}>
                          <Box
                            sx={{
                              flex: 1,
                              textAlign: "left",
                              padding: 2,
                              borderRight: {
                                xs: "none",
                                xl: "1px solid #e0e0e0",
                              },
                              borderBottom: {
                                xs: "1px solid #e0e0e0",
                                xl: "none",
                              },
                            }}
                          >
                            <Typography
                              className="font-size-11"
                              sx={{ letterSpacing: 1 }}
                            >
                              Overdue
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: 600, letterSpacing: 1 }}
                              onClick={() =>
                                handleOutstandingReceivablesNavigate("31to45")
                              }
                              className="blue-link text-link link-cursor bold-600"
                            >
                              31 - 45 Days
                            </Typography>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: 700 }}
                              className="font-size-16 red-color"
                            >
                              <NumberFormatWithSymbol
                                amount={
                                  dashboardData?.outStandingReceivables?.[0]
                                    ?.outstandingReceivable31to45DaysAmount || 0
                                }
                              />
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} xl={2.4}>
                          <Box sx={{ flex: 1, textAlign: "left", padding: 2 }}>
                            <Typography
                              className="font-size-11"
                              sx={{ letterSpacing: 1 }}
                            >
                              Overdue
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: 600, letterSpacing: 1 }}
                              onClick={() =>
                                handleOutstandingReceivablesNavigate("above45")
                              }
                              className="blue-link text-link link-cursor bold-600"
                            >
                              Above 45 Days
                            </Typography>

                            <Typography
                              variant="h5"
                              sx={{ fontWeight: 700 }}
                              className="font-size-16 red-color"
                            >
                              <NumberFormatWithSymbol
                                amount={
                                  dashboardData?.outStandingReceivables?.[0]
                                    ?.outstandingReceivable45DaysPlusAmount || 0
                                }
                              />
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                                        </div>
                    )}
                  </Card>
                </Grid>
                <Grid item xl={6} lg={6} xs={12} sm={12}>
                  <Card className="dashboard-card">
                    <CardContent
                      sx={{
                        padding: "16px 16px",
                      }}
                    >
                      <Box
                        display={"flex"}
                        sx={{ justifyContent: "space-between" }}
                      >
                        <Box>
                          <Typography
                            variant="h4"
                            className="dashboard-card-title"
                            fontWeight="bold"
                          >
                            Outstanding Payables
                          </Typography>
                          <Typography>
                            <h5
                              style={{
                                lineHeight: "1",
                                fontSize: "11px",
                                fontWeight: "400",
                              }}
                            >
                              Current Financial Year
                            </h5>
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                          onClick={() => {
                            navigate({
                              pathname: "/outstanding-payable-new",
                              search: `?sd=${userContext.financialYearStartDate}&ed=${userContext.financialYearEndDate}`,
                            });
                          }}
                          className="blue-link text-link link-cursor bold-600"
                        >
                          VIEW ALL
                        </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                    <Divider />
                    {isDashboardLoading ? (
                      <AgingStripSkeleton />
                    ) : (
                      <div className="dashboard-fade-in">
                    <Grid style={{ paddingLeft: 20, paddingTop: 10 }}>
                      <>
                        <Box>
                          <Typography
                            variant="h3"
                            className="dashboard-card-amount card-amount-h3"
                          >
                            <span className="dashboard-card-title">Total</span>
                            <span className="card-amount-h3-span">
                              <NumberFormatWithSymbol
                                amount={
                                  dashboardData?.outStandingPayables?.[0]
                                    ?.outstandingPayableTotalAmount || 0
                                }
                              />
                            </span>
                          </Typography>
                        </Box>
                      </>
                    </Grid>
                    <Grid
                      className="dashboard-bar-chart"
                      style={{
                        paddingLeft: 20,
                        paddingRight: 20,
                        paddingBottom: 20,
                      }}
                    >
                      <Grid
                        item
                        container
                        className="dashboard-aging-strip"
                        sx={{
                          border: "1px solid #e0e0e0",
                          borderRadius: "8px",
                          overflow: "hidden",
                          boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                          marginTop: 1,
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        <Grid item xs={12} sm={6} md={6} xl={2.4}>
                          <Box
                            sx={{
                              flex: 1,
                              textAlign: "left",
                              padding: 2,
                              height: "100%",
                              borderRight: {
                                xs: "none",
                                sm: "1px solid #e0e0e0",
                              },
                              borderBottom: {
                                xs: "1px solid #e0e0e0",
                                xl: "none",
                              },
                            }}
                          >
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: 600, letterSpacing: 1 }}
                              onClick={() =>
                                handleOutstandingPayablesNavigate("current")
                              }
                              className="blue-link text-link link-cursor bold-600"
                            >
                              Current Due
                            </Typography>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: 700 }}
                              className="font-size-16"
                            >
                              <NumberFormatWithSymbol
                                amount={
                                  dashboardData?.outStandingPayables?.[0]
                                    ?.outstandingPayableCurrentAmount || 0
                                }
                              />
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} xl={2.4}>
                          <Box
                            sx={{
                              flex: 1,
                              textAlign: "left",
                              padding: 2,
                              height: "100%",
                              borderRight: {
                                xs: "none",
                                xl: "1px solid #e0e0e0",
                              },
                              borderBottom: {
                                xs: "1px solid #e0e0e0",
                                xl: "none",
                              },
                            }}
                          >
                            <Typography
                              className="font-size-11"
                              sx={{ letterSpacing: 1 }}
                            >
                              Overdue
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: 600, letterSpacing: 1 }}
                              onClick={() =>
                                handleOutstandingPayablesNavigate("1to15")
                              }
                              className="blue-link text-link link-cursor bold-600"
                            >
                              1 - 15 Days
                            </Typography>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: 700 }}
                              className="font-size-16 red-color"
                            >
                              <NumberFormatWithSymbol
                                amount={
                                  dashboardData?.outStandingPayables?.[0]
                                    ?.outstandingPayable1to15DaysAmount || 0
                                }
                              />
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} xl={2.4}>
                          <Box
                            sx={{
                              flex: 1,
                              textAlign: "left",
                              padding: 2,
                              height: "100%",
                              borderRight: {
                                xs: "none",
                                sm: "1px solid #e0e0e0",
                              },
                              borderBottom: {
                                xs: "1px solid #e0e0e0",
                                xl: "none",
                              },
                            }}
                          >
                            <Typography
                              className="font-size-11"
                              sx={{ letterSpacing: 1 }}
                            >
                              Overdue
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: 600, letterSpacing: 1 }}
                              onClick={() =>
                                handleOutstandingPayablesNavigate("16to30")
                              }
                              className="blue-link text-link link-cursor bold-600"
                            >
                              16 - 30 Days
                            </Typography>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: 700 }}
                              className="font-size-16 red-color"
                            >
                              <NumberFormatWithSymbol
                                amount={
                                  dashboardData?.outStandingPayables?.[0]
                                    ?.outstandingPayable16to30DaysAmount || 0
                                }
                              />
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} xl={2.4}>
                          <Box
                            sx={{
                              flex: 1,
                              textAlign: "left",
                              padding: 2,
                              borderRight: {
                                xs: "none",
                                xl: "1px solid #e0e0e0",
                              },
                              borderBottom: {
                                xs: "1px solid #e0e0e0",
                                xl: "none",
                              },
                            }}
                          >
                            <Typography
                              className="font-size-11"
                              sx={{ letterSpacing: 1 }}
                            >
                              Overdue
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: 600, letterSpacing: 1 }}
                              onClick={() =>
                                handleOutstandingPayablesNavigate("31to45")
                              }
                              className="blue-link text-link link-cursor bold-600"
                            >
                              31 - 45 Days
                            </Typography>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: 700 }}
                              className="font-size-16 red-color"
                            >
                              <NumberFormatWithSymbol
                                amount={
                                  dashboardData?.outStandingPayables?.[0]
                                    ?.outstandingPayable31to45DaysAmount || 0
                                }
                              />
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} xl={2.4}>
                          <Box sx={{ flex: 1, textAlign: "left", padding: 2 }}>
                            <Typography
                              className="font-size-11"
                              sx={{ letterSpacing: 1 }}
                            >
                              Overdue
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: 600, letterSpacing: 1 }}
                              onClick={() =>
                                handleOutstandingPayablesNavigate("above45")
                              }
                              className="blue-link text-link link-cursor bold-600"
                            >
                              Above 45 Days
                            </Typography>
                            <Typography
                              variant="h5"
                              sx={{ fontWeight: 700 }}
                              className="font-size-16 red-color"
                            >
                              <NumberFormatWithSymbol
                                amount={
                                  dashboardData?.outStandingPayables?.[0]
                                    ?.outstandingPayable45DaysPlusAmount || 0
                                }
                              />
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                                        </div>
                    )}
                  </Card>
                </Grid>
              </Grid>
              <Grid container spacing={2} mb={2} mt={0.3}>
                <Grid item xl={4} lg={4} md={12} xs={12}>
                  <Card className="sale-container-main-1 dashboard-card ">
                    <CardContent
                      sx={{
                        padding: "16px 16px",
                      }}
                    >
                      <Box
                        display={"flex"}
                        sx={{ justifyContent: "space-between" }}
                      >
                        <Box>
                          <Typography
                            variant="h4"
                            className="dashboard-card-title"
                            fontWeight="bold"
                          >
                            Sale (INR)
                          </Typography>
                          <Typography>
                            <h5
                              style={{
                                lineHeight: "1",
                                fontSize: "11px",
                                fontWeight: "400",
                              }}
                            >
                              {dateHeading}
                            </h5>
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                    <Divider />
                    <Grid
                      className="dashboard-bar-chart"
                      style={{
                        paddingLeft: 8,
                        paddingRight: 8,
                        paddingBottom: 20,
                      }}
                    >
                      {isDashboardLoading ? (
                        <BarChartSkeleton />
                      ) : dashboardData?.saleChart?.chartData &&
                        dashboardData?.saleChart?.chartData.length > 0 ? (
                        <div className="dashboard-fade-in">
                          <ReactECharts option={axisAlignwithTick} />
                        </div>
                      ) : null}
                    </Grid>
                  </Card>
                </Grid>
                <Grid item xl={4} lg={4} md={6} xs={12}>
                  <Card className="sale-container-main-1">
                    <CardContent
                      sx={{
                        padding: "16px 16px",
                      }}
                    >
                      <Box
                        display={"flex"}
                        sx={{ justifyContent: "space-between" }}
                      >
                        <Box>
                          <Typography
                            variant="h4"
                            className="dashboard-card-title"
                            fontWeight="bold"
                          >
                            Most Sold Products
                          </Typography>
                          <Typography>
                            <h5
                              style={{
                                lineHeight: "1",
                                fontSize: "11px",
                                fontWeight: "400",
                              }}
                            >
                              {dateHeading}
                            </h5>
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                    <Divider />
                    <Box>
                      {isDashboardLoading ? (
                        <DonutChartSkeleton />
                      ) : (
                        <div className="dashboard-fade-in">
                          <ReactECharts option={doughnutChart} />
                        </div>
                      )}
                    </Box>
                  </Card>
                </Grid>
                <Grid item xl={4} lg={4} md={6} xs={12}>
                  <Card className="sale-container-main-1">
                    <CardContent sx={{ padding: "16px 16px" }}>
                      <Box
                        display={"flex"}
                        sx={{ justifyContent: "space-between" }}
                      >
                        <Box>
                          <Typography
                            variant="h4"
                            className="dashboard-card-title"
                            fontWeight="bold"
                          >
                            Bank and Cash
                          </Typography>
                          <Typography>
                            <h5
                              style={{
                                lineHeight: "1",
                                fontSize: "11px",
                                fontWeight: "400",
                              }}
                            >
                              Current Financial Year
                            </h5>
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>

                    <Divider />

                    {isDashboardLoading ? (
                      <BankCashSkeleton />
                    ) : (
                      <div className="dashboard-fade-in">
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          {["BANK_ACCOUNT", "CASH_IN_HAND"].map((code, index) => {
                            const item = dashboardData?.ledgerAccount?.find(
                              (acc) => acc.accountCode === code,
                            );
                            if (!item) return null;
                            return (
                              <React.Fragment key={code}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    px: 2,
                                    py: 1,
                                    position: "relative",
                                    zIndex: 1,
                                    "&:hover": {
                                      backgroundColor: isDarkMode
                                        ? "#1B2430"
                                        : "#f1f6fe",
                                    },
                                  }}
                                >
                                  <Typography
                                    onClick={() => handleNavigation(code, item)}
                                    className="text-link blue-link"
                                    sx={{ fontSize: 15 }}
                                  >
                                    {item?.ledgerAccountName || ""}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      color: isDarkMode ? "#818CF8" : "#1976d2",
                                      fontWeight: 500,
                                      fontSize: 15,
                                    }}
                                  >
                                    <NumberFormatWithSymbol
                                      amount={
                                        item?.ledgerAccountTotalAmount || 0
                                      }
                                    />
                                  </Typography>
                                </Box>
                                {index === 0 && <Divider />}
                              </React.Fragment>
                            );
                          })}
                        </Box>
                      </div>
                    )}
                  </Card>
                </Grid>
              </Grid>
              {!isDocumentLoading &&
                documentData?.documentCollection?.length > 0 && (
                <Box className="paper-container" sx={{ mb: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      pb: "10px",
                      alignItems: "center",
                    }}
                  >
                    <Box>
                      <Typography
                        variant="h4"
                        className="dashboard-card-title"
                        fontWeight="bold"
                      >
                        Near Expiry/Expired Documents
                      </Typography>
                    </Box>
                    <Box className="view-all">
                      <Typography
                        onClick={viewAllDocument}
                        className="blue-link text-link link-cursor bold-600"
                      >
                        VIEW ALL
                      </Typography>
                    </Box>
                  </Box>
                  <TableContainer>
                    <Table
                      aria-labelledby="tableTitle"
                      size={dense ? "small" : "medium"}
                    >
                      <EnhancedTableAllHead
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        //onSelectAllClick={handleCheckSelectAll}
                        //onRequestSort={handleRequestSort}
                        rowCount={documentData.documentCollection.length}
                      />
                      <TableBody>
                        {stableSort(
                          documentData.documentCollection,
                          getComparator(order, orderBy),
                        ).map((item: any, index: any) => {
                          const dateInLastMonth = isDateInLastMonth(
                            item.expirationDate,
                          );
                          const dateInNextTwoMonths = isDateInNextTwoMonths(
                            item.expirationDate,
                          );
                          return (
                            <TableRow hover key={item.documentId}>
                              <TableCell align="left">
                                <span
                                  style={{
                                    color: isDateInLastMonth(
                                      item.expirationDate,
                                    )
                                      ? "#d32f2f"
                                      : isDateInNextTwoMonths(
                                            item.expirationDate,
                                          )
                                        ? "#ed6c02"
                                        : "inherit",
                                  }}
                                  className={
                                    dateInLastMonth || dateInNextTwoMonths
                                      ? "bold-600"
                                      : ""
                                  }
                                >
                                  {item?.documentFor}
                                </span>
                                {"   "}
                                <Typography>
                                  <span
                                    style={{
                                      color: isDateInLastMonth(
                                        item.expirationDate,
                                      )
                                        ? "#d32f2f"
                                        : isDateInNextTwoMonths(
                                              item.expirationDate,
                                            )
                                          ? "#ed6c02"
                                          : "inherit",
                                    }}
                                    className={
                                      dateInLastMonth || dateInNextTwoMonths
                                        ? "bold-600"
                                        : ""
                                    }
                                  >
                                    {item?.documentForName}
                                  </span>
                                </Typography>
                              </TableCell>
                              <TableCell
                                sx={{
                                  display: {
                                    xs: "table-cell",
                                    sm: "table-cell",
                                    md: "table-cell",
                                    lg: "table-cell",
                                  },
                                }}
                                align="left"
                              >
                                <span>
                                  {item.code ? item.code + " - " : ""}
                                </span>
                                <span>
                                  {item.consumerId > 0 ? (
                                    <Button
                                      disableRipple
                                      color="inherit"
                                      className="manuButton-link"
                                      style={{
                                        backgroundColor: "transparent",
                                      }}
                                      onClick={() => {
                                        handleEditDocument(
                                          item.documentId,
                                          item?.documentForName,
                                          item?.tableName,
                                        );
                                      }}
                                    >
                                      <span className="text-link">
                                        {item.name}
                                      </span>
                                    </Button>
                                  ) : (
                                    <span>{item.name}</span>
                                  )}
                                </span>
                              </TableCell>
                              <TableCell
                                sx={{
                                  display: {
                                    xs: "table-cell",
                                    sm: "table-cell",
                                    md: "table-cell",
                                    lg: "table-cell",
                                  },
                                }}
                                align="left"
                              >
                                <span
                                  style={{
                                    color: isDateInLastMonth(
                                      item.expirationDate,
                                    )
                                      ? "#d32f2f"
                                      : isDateInNextTwoMonths(
                                            item.expirationDate,
                                          )
                                        ? "#ed6c02"
                                        : "inherit",
                                  }}
                                  className={
                                    dateInLastMonth || dateInNextTwoMonths
                                      ? "bold-600"
                                      : ""
                                  }
                                >
                                  {item.registrationNumber}
                                </span>
                              </TableCell>
                              <TableCell
                                sx={{
                                  display: {
                                    xs: "table-cell",
                                    sm: "table-cell",
                                    md: "table-cell",
                                    lg: "table-cell",
                                  },
                                }}
                                align="left"
                              >
                                <span
                                  style={{
                                    color: isDateInLastMonth(
                                      item.expirationDate,
                                    )
                                      ? "#d32f2f"
                                      : isDateInNextTwoMonths(
                                            item.expirationDate,
                                          )
                                        ? "#ed6c02"
                                        : "inherit",
                                  }}
                                  className={
                                    dateInLastMonth || dateInNextTwoMonths
                                      ? "bold-600"
                                      : ""
                                  }
                                >
                                  {item?.expirationDate
                                    ? format(
                                        new Date(item.expirationDate),
                                        "dd-MM-yyyy",
                                      )
                                    : ""}
                                </span>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                        {documentData?.documentCollection.length <= 0 ? (
                          <TableRow hover tabIndex={-1} key={"0"}>
                            <TableCell colSpan={8} align="center">
                              No record(s) found
                            </TableCell>
                          </TableRow>
                        ) : (
                          <></>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              )}

              <Box className="paper-container" sx={{ mb: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    pb: "10px",
                    alignItems: "center",
                  }}
                >
                  <Box>
                    <Typography
                      variant="h4"
                      className="dashboard-card-title"
                      fontWeight="bold"
                    >
                      Latest Invoices
                    </Typography>
                  </Box>
                  <Box
                    className="view-all"
                    sx={{ display: "flex", alignItems: "center", gap: 1 }}
                  >
                    <Typography
                      onClick={viewAllInvoice}
                      className="blue-link text-link link-cursor bold-600"
                    >
                      VIEW ALL
                    </Typography>
                    <Tool title="Customize Columns" placement="top">
                      <IconButton
                        aria-label="Settings"
                        onClick={handleSettingsOpen}
                        sx={{ p: 0 }}
                        disableRipple
                      >
                        <img src={CustomColumn} alt="Settings" height={20} />
                      </IconButton>
                    </Tool>
                    <Menu
                      anchorEl={settingsAnchorEl}
                      open={Boolean(settingsAnchorEl)}
                      onClose={handleSettingsClose}
                      MenuListProps={{ disablePadding: true }}
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      transformOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                      <MenuList sx={{ padding: 0 }}>
                        <Box
                          sx={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                          }}
                        >
                          <Box
                            sx={{
                              backgroundColor: "#dee6fa",
                              color: "#404d54",
                              padding: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            Settings
                          </Box>

                          <Box sx={{ maxHeight: "300px", overflowY: "auto" }}>
                            {reportConfigDetail?.map(
                              (configItem: any, index: number) => (
                                <MenuItem
                                  key={index}
                                  sx={{
                                    alignItems: "start",
                                    paddingLeft: "5px",
                                  }}
                                  onClick={() => {
                                    if (configItem?.isLocked) return;
                                    setReportConfigDetail((prev: any[]) =>
                                      prev.map((x) =>
                                        x.configKey === configItem?.configKey
                                          ? {
                                              ...x,
                                              isChecked: !configItem?.isChecked,
                                            }
                                          : x,
                                      ),
                                    );
                                  }}
                                >
                                  {configItem?.isLocked ? (
                                    <LockIcon />
                                  ) : (
                                    <Checkbox
                                      checked={configItem?.isChecked}
                                      sx={{ padding: 0, margin: 0 }}
                                    />
                                  )}

                                  <Typography
                                    sx={{
                                      fontSize: "13px !important",
                                      paddingLeft: "8px",
                                      fontWeight: "normal",
                                    }}
                                  >
                                    {configItem?.configKeyLabel}
                                  </Typography>
                                </MenuItem>
                              ),
                            )}
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              borderTop: "1px solid #ccc",
                              gap: "5px",
                              px: 2,
                              py: 1,
                            }}
                          >
                            <Button
                              size="small"
                              onClick={() => {
                                handleSettingsSave(reportConfigDetail);
                                handleSettingsClose();
                              }}
                              color="primary"
                              variant="contained"
                            >
                              Save
                            </Button>
                            <Button size="small" onClick={handleSettingsClose}>
                              Close
                            </Button>
                          </Box>
                        </Box>
                      </MenuList>
                    </Menu>
                  </Box>
                </Box>
                <TableContainer>
                  <Table
                    aria-labelledby="tableTitle"
                    size={dense ? "small" : "medium"}
                  >
                    <EnhancedTableHead
                      numSelected={selected.length}
                      order={order}
                      orderBy={orderBy}
                      onSelectAllClick={saleListSelectAll}
                      rowCount={resultData.saleCollection.length}
                      visibleColumns={latestInvoiceVisibleColumns}
                    />
                    <TableBody>
                      {isInvoiceListLoading ? (
                        <TableRowsSkeleton rows={5} />
                      ) : (
                        <>
                      {stableSort(
                        userContext.enableCompositionTax === true
                          ? resultData.saleCollection.filter(
                              (x) => x.saleType === 102,
                            )
                          : resultData.saleCollection.filter(
                              (x) => x.saleType === 1,
                            ),
                        getComparator(order, orderBy),
                      ).map((item: any, index: any) => {
                        const {
                          showVoucherNumber,
                          showVoucherDate,
                          showDueDate,
                          showQuantity,
                          showTotalAmount,
                          showStatus,
                          showProfitAmount,
                          showProfitPercent,
                        } = latestInvoiceVisibleColumns;
                        return (
                          <TableRow hover key={index}>
                            <TableCell>
                              <div style={{ display: "flex" }}>
                                <IconButton
                                  color="primary"
                                  onClick={() =>
                                    handleClickOpeninvoice(
                                      "paper",
                                      item?.saleId,
                                      item,
                                      0,
                                      "SALE",
                                    )
                                  }
                                >
                                  <LocalPrintshopIcon />
                                </IconButton>
                                <IconButton
                                  color="primary"
                                  onClick={() =>
                                    handleOpenInvoiceReportSeelctionDialogBox(
                                      item,
                                    )
                                  }
                                >
                                  <KeyboardArrowDownIcon />
                                </IconButton>
                              </div>
                            </TableCell>
                            {showVoucherNumber && (
                              <>
                                {matchesForInvoice ? (
                                  <TableCell
                                    onClick={() => saleEdit(item.saleId)}
                                  >
                                    <Grid container>
                                      <Grid item xs={12}>
                                        <Button
                                          disableRipple
                                          sx={{ justifyContent: "left" }}
                                          onClick={() => saleEdit(item.saleId)}
                                          className="manuButton-link"
                                          color="primary"
                                        >
                                          <span className="text-link">
                                            {item.saleNumber}
                                          </span>{" "}
                                        </Button>
                                      </Grid>
                                      <Grid item xs={12}>
                                        {format(
                                          new Date(item.saleDate),
                                          "dd-MM-yyyy",
                                        )}
                                      </Grid>
                                      <Grid
                                        item
                                        xs={12}
                                        display={{
                                          xs: "grid",
                                          sm: "none",
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            display: "flex",
                                            gap: "10px",
                                            py: 0.5,
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              justifyContent: "end",
                                            }}
                                          >
                                            {showStatus && (
                                              <span
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  marginBottom: 2,
                                                }}
                                              >
                                                <Alert
                                                  icon={false}
                                                  sx={{
                                                    width:
                                                      "fit-content !important",
                                                    paddingX: "6px !important",
                                                    paddingY: "0px !important",
                                                    fontWeight: "bold",
                                                    border: "none !important",
                                                    lineHeight:
                                                      "10px !important",
                                                    justifyContent: "center",
                                                  }}
                                                  variant="filled"
                                                  className={
                                                    ["PAID", "CLOSE"].includes(
                                                      item.saleStatus,
                                                    )
                                                      ? "tab-success"
                                                      : [
                                                            "PENDING",
                                                            "OPEN",
                                                          ].includes(
                                                            item.saleStatus,
                                                          )
                                                        ? "tab-warning"
                                                        : [
                                                              "SENT",
                                                              "PARTIAL_PAID",
                                                            ].includes(
                                                              item.saleStatus,
                                                            )
                                                          ? "tab-info"
                                                          : "tab-error"
                                                  }
                                                >
                                                  {item.saleStatusLabel}
                                                </Alert>
                                              </span>
                                            )}
                                            {showTotalAmount && (
                                              <span>
                                                {numberFormat(
                                                  item.finalGrandTotal,
                                                )}
                                              </span>
                                            )}
                                          </span>
                                          {item?.eWayBillId > 0 && (
                                            <BootstrapTooltip
                                              title={"E-way Bill"}
                                              placement="bottom"
                                            >
                                              <LocalShippingIcon
                                                sx={{ cursor: "pointer" }}
                                              />
                                            </BootstrapTooltip>
                                          )}
                                        </Box>
                                      </Grid>
                                      {matches ? (
                                        <Grid item xs={12}>
                                          {item.buyerName}
                                        </Grid>
                                      ) : (
                                        <Grid item xs={12}></Grid>
                                      )}
                                    </Grid>
                                  </TableCell>
                                ) : (
                                  <TableCell>
                                    <Button
                                      disableRipple
                                      sx={{ justifyContent: "left" }}
                                      onClick={() => saleEdit(item.saleId)}
                                      className="manuButton-link"
                                      color="primary"
                                    >
                                      <span className="text-link">
                                        {item.saleNumber}
                                      </span>{" "}
                                      <br />
                                    </Button>
                                    <Typography>{item.buyerName}</Typography>
                                  </TableCell>
                                )}
                              </>
                            )}
                            {showVoucherDate && (
                              <TableCell
                                sx={{
                                  display: {
                                    xs: "none",
                                    sm: "none",
                                    md: "table-cell",
                                  },
                                }}
                                align="center"
                              >
                                {format(new Date(item.saleDate), "dd-MM-yyyy")}
                              </TableCell>
                            )}
                            {showDueDate && (
                              <TableCell
                                sx={{
                                  display: {
                                    xs: "none",
                                    sm: "none",
                                    md: "table-cell",
                                  },
                                }}
                                align="center"
                              >
                                <DueDateColorInline item={item} />
                              </TableCell>
                            )}
                            {showQuantity && (
                              <TableCell
                                sx={{
                                  display: {
                                    xs: "none",
                                    sm: "none",
                                    md: "none",
                                    lg: "table-cell",
                                  },
                                }}
                                align="right"
                              >
                                {numberFormat(item.quantity, 3, 3)}
                              </TableCell>
                            )}
                            {showTotalAmount && (
                              <TableCell
                                onClick={() =>
                                  matchesForInvoice
                                    ? saleEdit(item.saleId)
                                    : null
                                }
                                sx={{
                                  display: {
                                    xs: "none",
                                    sm: "table-cell",
                                    md: "table-cell",
                                    lg: "table-cell",
                                  },
                                }}
                                align="right"
                              >
                                {matchesForInvoice ? (
                                  <Box sx={{ display: "flex", gap: "10px" }}>
                                    <span
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "end",
                                      }}
                                    >
                                      <span
                                        style={{
                                          display: "flex",
                                          justifyContent: "end",
                                          marginBottom: 2,
                                        }}
                                      >
                                        <Alert
                                          icon={false}
                                          sx={{
                                            width: "fit-content !important",
                                            paddingX: "6px !important",
                                            paddingY: "0px !important",
                                            fontWeight: "bold",
                                            border: "none !important",
                                            lineHeight: "10px !important",
                                            justifyContent: "center",
                                          }}
                                          variant="filled"
                                          className={
                                            ["PAID", "CLOSE"].includes(
                                              item.saleStatus,
                                            )
                                              ? "tab-success"
                                              : ["PENDING", "OPEN"].includes(
                                                    item.saleStatus,
                                                  )
                                                ? "tab-warning"
                                                : [
                                                      "SENT",
                                                      "PARTIAL_PAID",
                                                    ].includes(item.saleStatus)
                                                  ? "tab-info"
                                                  : "tab-error"
                                          }
                                        >
                                          {item.saleStatusLabel}
                                        </Alert>
                                      </span>
                                      <span>
                                        {numberFormat(item.finalGrandTotal)}
                                      </span>
                                    </span>
                                    {item?.eWayBillId > 0 && (
                                      <BootstrapTooltip
                                        title={"E-way Bill"}
                                        placement="bottom"
                                      >
                                        <LocalShippingIcon
                                          sx={{ cursor: "pointer" }}
                                        />
                                      </BootstrapTooltip>
                                    )}
                                  </Box>
                                ) : (
                                  <span>
                                    {numberFormat(item.finalGrandTotal)}
                                  </span>
                                )}
                              </TableCell>
                            )}
                            {showStatus && (
                              <TableCell
                                sx={{
                                  display: {
                                    xs: "none",
                                    sm: "none",
                                    md: "table-cell",
                                    lg: "table-cell",
                                  },
                                }}
                                align="right"
                              >
                                {" "}
                                <Box sx={{ display: "flex", gap: "10px" }}>
                                  <Alert
                                    icon={false}
                                    sx={{
                                      width: "fit-content !important",
                                      paddingX: "6px !important",
                                      paddingY: "0px !important",
                                      fontWeight: "bold",
                                      border: "none !important",
                                      lineHeight: "10px !important",
                                      justifyContent: "center",
                                    }}
                                    variant="filled"
                                    className={
                                      ["PAID", "CLOSE"].includes(
                                        item.saleStatus,
                                      )
                                        ? "tab-success"
                                        : ["PENDING", "OPEN"].includes(
                                              item.saleStatus,
                                            )
                                          ? "tab-warning"
                                          : ["SENT", "PARTIAL_PAID"].includes(
                                                item.saleStatus,
                                              )
                                            ? "tab-info"
                                            : "tab-error"
                                    }
                                  >
                                    {item.saleStatusLabel}
                                  </Alert>
                                  {item?.eWayBillId > 0 && (
                                    <BootstrapTooltip
                                      title={"E-way Bill"}
                                      placement="bottom"
                                    >
                                      <LocalShippingIcon
                                        sx={{ cursor: "pointer" }}
                                      />
                                    </BootstrapTooltip>
                                  )}
                                </Box>
                              </TableCell>
                            )}
                            {showProfitAmount && (
                              <TableCell
                                sx={{
                                  display: {
                                    xs: "none",
                                    sm: "none",
                                    md: "table-cell",
                                    lg: "table-cell",
                                  },
                                }}
                                align="right"
                              >
                                {numberFormat(item?.profitAmount)}
                              </TableCell>
                            )}
                            {showProfitPercent && (
                              <TableCell
                                sx={{
                                  display: {
                                    xs: "none",
                                    sm: "none",
                                    md: "table-cell",
                                    lg: "table-cell",
                                  },
                                }}
                                align="right"
                              >
                                {numberFormat(item?.profitPercentage) + '%'}
                              </TableCell>
                            )}
                            <TableCell
                              sx={{
                                display: {
                                  xs: "table-cell",
                                  sm: "table-cell",
                                  md: "table-cell",
                                  lg: "table-cell",
                                },
                              }}
                              align="right"
                            >
                              <Tool title="More" placement="top">
                                <IconButton
                                  onClick={(e: any) =>
                                    handleClickOpenMore(e, item.saleId, item)
                                  }
                                >
                                  <MoreVertIcon />
                                </IconButton>
                              </Tool>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                      {resultData.saleCollection.length <= 0 ? (
                        //<TableBody>
                        <TableRow>
                          <TableCell colSpan={17} align="center">
                            No record(s) found
                          </TableCell>
                        </TableRow>
                      ) : (
                        //</TableBody>
                        <></>
                      )}
                        </>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          ) : (
            <MissingConsumer consumerId={userContext.consumerId} />
          )}
        </>
      )}
      <Popover
        elevation={1}
        open={open}
        anchorEl={anchorEl}
        onClose={handleCloseD}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Typography sx={{ padding: "0px !important" }} padding={1}>
          <List aria-label="invoice-actions" sx={{ padding: "0px !important" }}>
            <ListItem divider className="invoice-action-icons-container" button>
              <IconButton
                color="primary"
                onClick={() =>
                  handleClickOpeninvoice(
                    "paper",
                    dialogSaleData.saleId,
                    dialogSaleData,
                    0,
                    "SALE",
                  )
                }
              >
                <LocalPrintshopIcon />
              </IconButton>
              <IconButton
                color="primary"
                onClick={() =>
                  handleOpenInvoiceReportSeelctionDialogBox(dialogSaleData)
                }
              >
                <KeyboardArrowDownIcon />
              </IconButton>
              <IconButton
                color="primary"
                onClick={() => {
                  handleClickOpeninvoice(
                    "paper",
                    dialogSaleData.saleId,
                    dialogSaleData,
                    1,
                    "SALE",
                  );
                }}
              >
                <DownloadIcon />
              </IconButton>
              <IconButton
                color="primary"
                onClick={() => {
                  handleClickOpenSendEmail(true, dialogSaleData);
                }}
              >
                <SendRoundedIcon
                  style={{
                    rotate: "690deg",
                    marginLeft: "3px",
                    marginBottom: "3px",
                  }}
                />
              </IconButton>
            </ListItem>
            <Divider />
            {!userContext?.enableCompositionTax &&
              EWAY_BILL_ACCESS_CONSUMERS.includes(userContext.consumerId) && (
                <>
                  {dialogSaleData.eWayBillId <= 0 && (
                    <ListItemButton
                      className="listitem"
                      onClick={() => {
                        GenerateEWayBill(dialogSaleData.saleId, "tax-invoice");
                      }}
                    >
                      <ListItemText primary="Generate E-Way Bill" />
                    </ListItemButton>
                  )}
                  {dialogSaleData.eInvoiceId > 0 && (
                    <ListItemButton
                      onClick={() => {
                        handleClickOpeninvoice(
                          "paper",
                          dialogSaleData.saleId,
                          dialogSaleData,
                          0,
                          "EINVOICE",
                        );
                      }}
                    >
                      <ListItemText primary={`Print E-Invoice`} />
                    </ListItemButton>
                  )}
                  {dialogSaleData.eWayBillId > 0 && (
                    <>
                      <Divider />
                      <ListItemButton
                        onClick={() => {
                          handleClickOpeninvoice(
                            "paper",
                            dialogSaleData.saleId,
                            dialogSaleData,
                            0,
                            "EWAYBILLDRIVERCOPY",
                          );
                        }}
                      >
                        <ListItemText primary={`E-Way Bill Driver Copy`} />
                      </ListItemButton>
                      <ListItemButton
                        onClick={() => {
                          handleClickOpeninvoice(
                            "paper",
                            dialogSaleData.saleId,
                            dialogSaleData,
                            0,
                            "EWAYBILLORIGINAL",
                          );
                        }}
                      >
                        <ListItemText primary={`E-Way Bill Original Copy`} />
                      </ListItemButton>
                    </>
                  )}
                  {dialogSaleData.eWayBillId > 0 && (
                    <>
                      <Divider />
                      {EwayBillActions.map((item: any, index: number) => {
                        return (
                          <ListItemButton
                            key={index}
                            onClick={() => {
                              handleEWayBillAction(item.value);
                            }}
                          >
                            <ListItemText primary={`${item.label}`} />
                          </ListItemButton>
                        );
                      })}
                    </>
                  )}
                </>
              )}
            <Divider />
            <ListItemButton
              className="listitem"
              onClick={() => saleEdit(dialogSaleData.saleId)}
            >
              <ListItemText primary="Edit" />
            </ListItemButton>
            <ListItemButton
              className="delete-container"
              onClick={handleClickOpen}
            >
              Delete
            </ListItemButton>
          </List>
        </Typography>
      </Popover>
      <Dialog
        open={openDilog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this Invoice?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => deleteRow(saleId)} className="button-delete">
            Yes
          </Button>
          <Button onClick={handleClose} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
      {openInvoice && (reportName?.startsWith("TransportInvoice") ? !!transportInvoiceData : invoiceHtml !== "") && (
        <Dialog
          fullScreen={fullScreen}
          open={openInvoice && (reportName?.startsWith("TransportInvoice") ? !!transportInvoiceData : invoiceHtml !== "")}
          onClose={handleCloseInvoice}
          maxWidth="md"
          fullWidth
        >
          {reportName?.startsWith("TransportInvoice") ? (
            reportName === "TransportInvoice_BodyOnly" ? (
              <TransportInvoiceBodyOnlyPreview
                open={openInvoice}
                onClose={handleCloseInvoice}
                data={transportInvoiceData}
                handleClickOpenSendEmail={handleClickOpenSendEmail}
                itemData={itemData}
                template={reportName}
              />
            ) : reportName === "TransportInvoice_2Page" ? (
              <TransportationDetailsReportPreview
                open={openInvoice}
                onClose={handleCloseInvoice}
                data={transportInvoiceData}
                handleClickOpenSendEmail={handleClickOpenSendEmail}
                handleClickOpenSendWhatsapp={handleClickOpenSendWhatsapp}
                itemData={itemData}
                template={reportName}
              />
            ) : (
              <TransportInvoicePreview
                open={openInvoice}
                onClose={handleCloseInvoice}
                data={transportInvoiceData}
                handleClickOpenSendEmail={handleClickOpenSendEmail}
                itemData={itemData}
                template={reportName}
              />
            )
          ) : (
            <PdfViewer
              openInvoice={openInvoice}
              handleCloseInvoice={handleCloseInvoice}
              invoiceHtmlTitle={invoiceHtmlTitle}
              invoiceHtml={invoiceHtml}
              invoiceTitle={invoiceTitle}
              fileUrl={url}
              handleClickOpenSendEmail={handleClickOpenSendEmail}
              itemData={itemData}
              fileName={InvoiceName}
              handleDownload={() => {
                if (InvoiceName === "SALE") {
                  openInvoicePopup(
                    itemData?.saleId,
                    1,
                    reportName || defaultinvoiceNameObj,
                  );
                } else if (InvoiceName === "EINVOICE") {
                  handlePrintEInvoiceCopy(itemData?.saleId, 1);
                } else if (InvoiceName === "EWAYBILLORIGINAL") {
                  handlePrintEwayBillOriginalCopy(
                    itemData?.eWayBillId,
                    itemData?.eWayBillNo,
                    1,
                  );
                } else if (InvoiceName === "EWAYBILLDRIVERCOPY") {
                  handlePrintEwayBillDriverCopy(
                    itemData?.eWayBillId,
                    itemData?.eWayBillNo,
                    1,
                  );
                }
              }}
              isforSmallDevice={fullScreen}
              isLoading={isLoading}
            />
          )}
        </Dialog>
      )}

      <EmailDialog
        isOpen={isOpen}
        isCloseSendEmail={isCloseSendEmail}
        Id={dataId}
        reportName={reportName}
        pdfFileName={pdfFileName}
        page={invoiceHtmlTitle}
        finalTotalAmount={finalTotalAmount}
        userName={userName}
        itemData={itemData}
      />
      <Dialog
        fullScreen={fullScreen}
        open={invoiceReportSelectionDialog}
        onClose={handleCloseInvoiceReportSeelctionDialogBox}
        aria-labelledby="responsive-dialog-title"
        ref={containerRef}
        scroll={"paper"}
        sx={{ "& .MuiDialog-paper": { minWidth: !fullScreen ? 435 : "100%" } }}
      >
        <DialogTitle
          className="scroll-dialog-title-container"
          sx={{ paddingBottom: "0px !important" }}
        >
          <Grid container className="head-dialog-box-container">
            <Grid item xs={11}>
              <h3>
                <b> Invoice Template</b>
              </h3>
              <span style={{ fontSize: "15px" }}>
                Select Your Invoice Template
              </span>
            </Grid>
            <Grid item xs={1} sx={{ paddingTop: "2px" }}>
              <BootstrapTooltip title={"Close"} placement="top">
                <IconButton
                  aria-label="close"
                  onClick={handleCloseInvoiceReportSeelctionDialogBox}
                  style={{ marginTop: "-10px !important" }}
                >
                  <CloseIcon />
                </IconButton>
              </BootstrapTooltip>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent
          style={{ padding: "8px 0px 12px 20px", marginRight: "25px" }}
        >
          <Box>
            {
              <InvoiceTemplateSelection
                onselect={(item) => handleListItemInvoiceTemplateClick(item)}
              />
            }
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
